import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  HostListener,
  AfterViewInit,
  ChangeDetectorRef,
  OnDestroy,
} from '@angular/core';
import { ProdutosService } from '../../services/produtos/produto.service';
import { GrupoService } from '../../services/grupo/grupo.service';
import { debounceTime, firstValueFrom, forkJoin, interval, map, of, Observable, Subject, Subscription, catchError, switchMap, take, tap } from 'rxjs';
import { Router } from '@angular/router';
import { PessoaService } from '../../services/pessoas/pessoas.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TipoDeDesconto } from '../../enums/TipoDeDesconto.enum';
import { FormaDePagamento } from '../../enums/FormaDePagamento.enum';
import { NotaService } from '../../services/financeiro/notas.service';
import { UsuarioService } from '../../services/usuario/usuario.service';
import { EmpresaConfigService } from '../../services/configuracoes/empresa.service';
import { TimbradoService } from '../../services/configuracoes/timbrado.service';
import { ContaService } from '../../services/conta/conta.service';
import { CotacaoService } from '../../services/cotacao/cotacao.service';
import { CotacaoGuardService } from '../../services/cotacao/cotacao-guard.service';
import { CotacaoDialogService } from '../../services/cotacao/cotacao-dialog.service';
import { environment } from '../../environments/environment';
import { CarrinhoService } from '../../services/carrinho.service';
import { TranslateService } from '@ngx-translate/core';
import { Dropdown } from 'primeng/dropdown';
import { InputNumber } from 'primeng/inputnumber';
import { TipoPadraoNota } from '../../enums/TipoPadraoNota.enum';
import { ItemsService } from '../../services/financeiro/item.service';
import { NotaDTO, ItemDeNotaDTO, VarianteDePrecoDeItemPedidoDTO, ModificadorDePrecoDeItemPedidoDTO } from '../../models/nota.model';
import { toLocalISOString } from '../../shared/utils/date-utils';
import { sanitizarMensagemErro, extrairMensagemErroHttp } from '../../shared/utils/error-utils';
import { converterDireto, ConversaoNaoPermitidaError } from '../../shared/utils/moeda-conversao.util';
import { enumMoedaParaIso, podeConverterEntre } from '../../utils/moeda-pareamento.util';
import { ItemDTO } from '../../models/item.model';
import { FormaPagamentoResult, DadosPagamentoDinheiro, DadosPagamentoConta, DadosPagamentoPrazo, DadosPagamentoCartao, DadosPagamentoQrCode, EstadoQrCodePagamento } from '../../shared/components/forma-pagamento-dialog/forma-pagamento-dialog.interfaces';
import { IntencaoDeRecebimentoService } from '../../services/financeiro/intencao-de-recebimento.service';
import { NfeService } from '../../services/financeiro/nfe.service';
import { PessoaDTO } from '../../models/clientes/pessoa.model';
import { EntitySelectorComponent } from '../../shared/components/entity-selector/entity-selector.component';
import { EntitySelectorConfig } from '../../shared/components/entity-selector/entity-selector.interfaces';
import { PessoaAdicionarDialogComponent } from '../../shared/components/pessoa-adicionar-dialog/pessoa-adicionar-dialog.component';
import { ProdutoVarianteModificadorService } from '../../services/produto-variante-modificador/produto-variante-modificador.service';
import {
  VarianteDePrecoDeItemDTO,
  GrupoDeModificadorDePrecoDeItemDTO,
  ModificadorDePrecoDeItemDTO,
} from '../../models/produto-variante-modificador/produto-variante-modificador.model';
import { PermissaoService } from '../../services/permissao/permissao.service';
import { PlanosService } from '../../services/planos/planos.service';
import { observacaoItemParaExibicao } from '../../shared/utils/observacao-item.util';

interface TipoDeDescontoOption {
  label: string;
  value: string;
}

/** Estrutura das opções do dropdown de Timbrado */
type TimbradoOption = {
  value: any | null;
  id: number | null;
  label?: string;
};

/** O que aparece embaixo do nome do item: nada, o codigo interno ou o de barras. */
type ExibicaoCodigo = 'NENHUM' | 'CODIGO' | 'BARRAS';

@Component({
  selector: 'app-vendas',
  templateUrl: './vendas.component.html',
  styleUrls: ['./vendas.component.scss'],
  providers: [ConfirmationService, MessageService],
})
export class VendasComponent implements OnInit, AfterViewInit, OnDestroy {
  env = environment;

  // produtos
  produtos: any[] = [];
  private produtosBrutos: any[] = [];
  loading = false;
  paginaAtual = 0;
  tamanhoPagina = 10;
  totalPaginas = 0;
  totalElements = 0;

  // Opcoes do seletor "Itens por pagina" (formato {label, value} igual as demais
  // telas). Mesmos valores que antes viviam em [rowsPerPageOptions].
  pageSizeOptions = [
    { label: 5, value: 5 },
    { label: 10, value: 10 },
    { label: 20, value: 20 },
    { label: 120, value: 120 },
  ];
  private _ultimoTamanhoPagina = 10;

  termoBusca$ = new Subject<string>();
  produtoNaoEncontrado = false;

  // filtros
  grupos: any[] = [];
  categoriaSelecionada: any = { id: null, nome: 'Todas' };
  mostrarSemSaldo = true;

  // empresa/usuario
  idEmpresa: string = '';
  private vendedorPessoaId: number | null = null;

  // carrinho + cache
  carrinho: any[] = [];

  // ---------------------------------------------------------------------------
  // Qual codigo aparece embaixo do nome do item
  //
  // UMA escolha para a tela: vale para o card da grade e para a linha do
  // carrinho. Nasce em NENHUM — quem vende pelo nome nao quer o codigo no card.
  // ---------------------------------------------------------------------------

  readonly STORAGE_CODIGO = 'vendas-codigo';
  exibicaoCodigo: ExibicaoCodigo = 'NENHUM';
  codigoOptions: { label: string; value: ExibicaoCodigo }[] = [];

  /** Termo que originou a busca em curso, para a adicao automatica por codigo. */
  private termoFiltroAtual = '';

  /** Codigo de barras que ja entrou sozinho, para nao repetir a cada recarga. */
  private codigoJaAutoAdicionado = '';

  /** Termo como foi digitado, com o eventual prefixo "<qtd>*". */
  private termoBrutoAtual = '';
  private cacheRevalidado = false;
  private get cacheKey() {
    return `vendas_cache_${this.idEmpresa || 'semEmpresa'}`;
  }

  // dropdowns / segundo painel
  clienteSelecionado: PessoaDTO | undefined;

  // Configuracao do entity-selector para cliente
  clienteSelectorConfig!: EntitySelectorConfig;

  timbrados: TimbradoOption[] = [];
  timbradoSelecionado: TimbradoOption = { value: null, id: -1 };
  timbradoSelecionadoId: number = -1;

  private clientePadraoId: number | null = null;
  private timbradoPadraoLabel: string | null = null;
  private timbradoPadraoId: number | null = null;

  // descontos
  subtotal = 0;
  descontos = 0;
  tipoDeDesconto: TipoDeDescontoOption | null = null;
  valorDesconto: number | null = null;
  mostrarDialogDesconto = false;

  observacao: string = '';
  pedidoIdDoCache: number | null = null;
  /** Flag: faturamento atual originou de um pedido — usado para redirecionar após fechar o dialog de fatura */
  private veioDePedido = false;
  /** Id do pedido faturado para reabrir o modal automaticamente ao retornar para /pedidos */
  private pedidoIdParaReabrir: number | null = null;
  pessoa_id: number | null = null;
  itemDeNota: any[] = [];

  // modal pagamento
  mostrarDialogPagamento = false;
  formaPagamentoSelecionada: 'dinheiro' | 'conta' | 'prazo' = 'dinheiro';
  processandoVenda = false; // Proteção contra duplo clique (BLOCO 6 - Tarefa 6.1)

  tiposDeDesconto: TipoDeDescontoOption[] = Object.values(TipoDeDesconto).map((value) => ({
    label: value.replace('_', ' '),
    value,
  }));

  contas: any[] = [];

  /** Contas marcadas para receber tarjeta/QR Code (GET /conta/tarjeta-qrcode). */
  contasTarjetaQrcode: any[] = [];

  /** A empresa ja configurou os dados de recebimento (Bancard). */
  bancardConfigurado = false;

  /**
   * Conta onde o dinheiro cobrado por QR Code entra, escolhida em Dados de recebimento.
   *
   * O operador nao escolhe conta no QR: a cobranca sai pelo cadastro da Bancard da empresa, que
   * aponta para uma conta so. `null` quando a empresa ainda nao vinculou — o dialogo entao
   * orienta a cadastrar, porque sem conta nao ha onde lancar o recebimento.
   */
  contaQrCode: { id: number; label: string } | null = null;
  private contaQrCodeId: number | null = null;
  private contasBancariasGuarani: any[] = [];

  /**
   * Estado da cobranca por QR Code exibida no dialogo de pagamento.
   * Quem confirma o pagamento e o callback da Bancard — a tela apenas observa.
   */
  estadoQrCode: EstadoQrCodePagamento = { gerando: false, confirmado: false };

  /** Assinatura do polling do QR; encerrada ao confirmar, cancelar ou sair da tela. */
  private pollingQrCodeSub?: Subscription;
  contaSelecionada: any = null;
  informacaoDaTransacao: string = '';
  numeroParcelas: number = 1;
  titulos: any[] = [];

  // moeda
  moedaPadrao: 'BRL' | 'PYG' | 'USD' | 'ARS' = 'BRL';
  private readonly moedaIsoParaEnum: Record<string, string> = {
    'PYG': 'GUARANI',
    'BRL': 'REAL',
    'USD': 'DOLAR',
    'ARS': 'PESO'
  };

  /**
   * Moeda da nota (= moeda padrao da empresa) no formato enum, para alimentar
   * o `[moedaNota]` do forma-pagamento-dialog — que filtra o dropdown de
   * contas, ocultando moedas incompativeis (espelha MoedaPareamentoValidator).
   */
  get moedaNotaEnum(): string {
    return this.moedaIsoParaEnum[this.moedaPadrao] || 'GUARANI';
  }
  localeMoeda: string = 'pt-BR';
  digitsMoeda: string = '1.2-2';
  digitsMoedaPYG: string = '1.0-0';

  // cotações mock (USD como base)
  cotUSD = 1;
  cotPYG = 7180; // PYG por 1 USD
  cotBRL = 5.47; // BRL por 1 USD
  /** PYG por 1 ARS (peso argentino). 0 quando nao ha cotacao cadastrada. */
  cotPesoGuarani = 0;
  /** PYG por 1 BRL (cotacao direta). 0 = triangulacao via USD como fallback. */
  cotRealGuarani = 0;

  corTotalEnviadoDinheiro: string = 'red';

  dataAtualFormatada: string = '';

  // dinheiro – valores numéricos
  valorRecebidoEmGuarani: number = 0;
  valorRecebidoEmDolar: number = 0;
  valorRecebidoEmReal: number = 0;
  // dinheiro – strings mostradas nos inputs
  valorGuaraniStr: string = '';
  valorDolarStr: string = '';
  valorRealStr: string = '';

  totalPago: number = 0;     // em PYG (para exibição agregada)
  totalTroco: number = 0;    // em PYG
  totalEnviado: number = 0;  // em PYG

  /** linha selecionada na tabela de dinheiro para highlight */
  selectedMoneyCode: 'PYG' | 'USD' | 'BRL' = 'BRL';

    // troco – valores numéricos (independentes dos valores recebidos)
  trocoGuarani: number = 0;
  trocoDolar: number = 0;
  trocoReal: number = 0;
  // troco – strings mostradas nos inputs
  trocoGuaraniStr: string = '';
  trocoDolarStr: string = '';
  trocoRealStr: string = '';

  // ViewChilds para focos
  @ViewChild('searchInput') searchInputRef!: ElementRef<HTMLInputElement>;
  @ViewChild('tipoDescDD') tipoDescDD?: Dropdown;
  @ViewChild('valorDescontoInput') valorDescontoInput?: InputNumber;
  @ViewChild('contaDD') contaDD?: Dropdown;
  @ViewChild('inputGuarani') inputGuarani?: ElementRef<HTMLInputElement>;
  @ViewChild('numeroParcelasInput') numeroParcelasInput?: ElementRef<HTMLInputElement>;
  @ViewChild('inputNovoPreco') inputNovoPreco?: ElementRef<HTMLInputElement>;
  @ViewChild('observacaoInput') observacaoInput?: ElementRef<HTMLTextAreaElement>;
  @ViewChild('btnConfirmarLimparCarrinho') btnConfirmarLimparCarrinho?: ElementRef<HTMLButtonElement>;
  @ViewChild('btnImprimirFatura') btnImprimirFatura?: ElementRef<HTMLButtonElement>;
  @ViewChild('timbradoDD') timbradoDD?: Dropdown;
  @ViewChild('clienteSelector') clienteSelector!: EntitySelectorComponent;

  // ---- Dialog "preço zero" ----
  mostrarDialogPreco = false;
  produtoParaDefinirPreco: any = null;
  precoVendaAtualFormatado = '';
  precoVendaNovoStr = '';
  valorNovoPrecoNumber = 0;

  // ---- Modal F9 - Novo Cliente ----
  mostrarDialogNovoCliente = false;

  @ViewChild(PessoaAdicionarDialogComponent) pessoaDialog?: PessoaAdicionarDialogComponent;

  // ---- Cotação (dialogo global via CotacaoDialogService) ----

  // ---- Observacao por item do carrinho (paridade com Criar Pedido) ----
  mostrarDialogObservacaoItem = false;
  observacaoItemEmEdicao = '';
  private itemObservacaoEmEdicao: any = null;

  // ---- Remover Item Modal ----
  mostrarDialogRemoverItem = false;
  itemParaRemover: any = null;

  // ---- Limpar Carrinho Modal ----
  mostrarDialogImportarPedido = false;
  mostrarDialogLimparCarrinho = false;

  // ---- Detalhe do produto (modal central com carrossel de imagens) ----
  // Fluxo lazy: GET das imagens secundarias so dispara quando este valor passa a ser nao-nulo.
  produtoDetalheAberto: any | null = null;

  // ---- Dialog Variantes e Modificadores ----
  mostrarDialogVarianteModificador = false;
  produtoParaVariante: any = null;
  variantesDisponiveis: VarianteDePrecoDeItemDTO[] = [];
  gruposModificadores: GrupoDeModificadorDePrecoDeItemDTO[] = [];
  varianteSelecionada: VarianteDePrecoDeItemDTO | null = null;
  // grupoId -> (modId -> quantidade)
  modificadoresQuantidade: Map<number, Map<number, number>> = new Map();
  precoCalculadoVariante = 0;
  carregandoVariantes = false;

  // Cache de variantes/grupos por item_id (evitar chamadas HTTP repetidas)
  private cacheVariantes = new Map<number, VarianteDePrecoDeItemDTO[]>();
  private cacheGruposModificadores = new Map<number, GrupoDeModificadorDePrecoDeItemDTO[]>();

  // ---- Dialog Dados Cliente NFe ----
  mostrarDialogDadosClienteNfe = false;
  camposFaltantesNfe: string[] = [];

  // ---- Dialog Atalhos de Teclado ----
  mostrarDialogAtalhos = false;

  // ---- Dialog Selecao do Multiplicador ----
  // Quando "<qtd>*<termo>" retorna multiplos itens (sem match exato), abrir dialog
  // de selecao para o usuario escolher qual item entra no carrinho com a quantidade.
  mostrarDialogSelecaoMultiplicador: boolean = false;
  itensDialogSelecao: any[] = [];
  quantidadeDialogSelecao: number = 0;
  codigoDialogSelecao: string = '';
  // Paginacao client-side do dialog de selecao do multiplicador.
  paginaAtualDialog: number = 0;
  tamanhoPaginaDialog: number = 6;

  /** Itens visiveis na pagina atual do dialog de selecao do multiplicador. */
  get itensDialogSelecaoPaginados(): any[] {
    const inicio = this.paginaAtualDialog * this.tamanhoPaginaDialog;
    return this.itensDialogSelecao.slice(inicio, inicio + this.tamanhoPaginaDialog);
  }

  // ---- Fatura Após Venda ----
  idNotaGerada: number | null = null;
  notaGerada: any = null;

  // ---- Dialogo Fatura Pos-Venda ----
  mostrarDialogoFatura: boolean = false;
  notaCarregada: NotaDTO | null = null;
  itensCarregados: ItemDTO[] = [];
  carregandoFatura: boolean = false;
  /** Timestamp da abertura do dialog de fatura — usado para ignorar Enter residual do pagamento */
  private dialogFaturaAbertoEm: number = 0;

  // ---- Sub-dialogo Impressao ----
  mostrarDialogoImpressaoFatura: boolean = false;
  opcaoImpressaoFatura: string = 'A4';
  isImprimindoFatura: boolean = false;

  // ---- Opcao de impressao da empresa ----
  private tipoImprimir: string = 'PERGUNTAR';

  /**
   * Flag da empresa "Imprimir ficha do evento" (mesma usada em fatura-view).
   * Quando ativa, o dialogo pos-venda tambem oferece o botao "Imprimir Ficha",
   * evitando que o usuario precise abrir a tela de fatura so para isso.
   */
  deveImprimirFicha: boolean = false;
  isImprimindoFicha: boolean = false;

  // ---- Dialog Limite do Plano ----
  mostrarDialogLimitePlano = false;
  temPermissaoConfiguracao = false;

  // ---- Dialogo Transmissao Automatica ----
  mostrarDialogoTransmissao: boolean = false;
  transmissaoProgresso: number = 0;
  transmissaoEstado: 'transmitindo' | 'sucesso' | 'erro' = 'transmitindo';
  transmissaoMensagem: string = '';
  idNotaParaTransmissao: number | null = null;

  // Expose Math to template
  Math = Math;

  // Controle de UI - imagens com erro (exibir SVG placeholder)
  imagensComErro: Set<string> = new Set();

  constructor(
    private produtosService: ProdutosService,
    private grupoService: GrupoService,
    private pessoaService: PessoaService,
    private confirmationService: ConfirmationService,
    private notaService: NotaService,
    private usuarioService: UsuarioService,
    private empresaConfigService: EmpresaConfigService,
    private timbradoService: TimbradoService,
    private contaService: ContaService,
    private messageService: MessageService,
    private cotacaoService: CotacaoService,
    private cotacaoDialogService: CotacaoDialogService,
    private cotacaoGuard: CotacaoGuardService,
    private carrinhoService: CarrinhoService,
    private itemsService: ItemsService,
    private translate: TranslateService,
    private router: Router,
    private cdRef: ChangeDetectorRef,
    private nfeService: NfeService,
    private produtoVarianteModificadorService: ProdutoVarianteModificadorService,
    private permissaoService: PermissaoService,
    private planosService: PlanosService,
    private intencaoDeRecebimentoService: IntencaoDeRecebimentoService,
  ) {}

  // HOTKEYS
  @HostListener('document:keydown', ['$event'])
  onGlobalKeydown(ev: KeyboardEvent) {

    // --- Escape: fechar dialogs abertos (prioridade maxima) ---
    if (ev.key === 'Escape') {
      // Dialog de selecao do multiplicador tem prioridade maxima:
      // ele eh o ponto de entrada do fluxo e pode encadear outros dialogs em cascata.
      if (this.mostrarDialogSelecaoMultiplicador) {
        ev.preventDefault();
        this.cancelarDialogSelecaoMultiplicador();
        return;
      }
      if (this.mostrarDialogoTransmissao) {
        if (this.transmissaoEstado === 'erro') {
          ev.preventDefault();
          this.fecharDialogoTransmissaoEVerFatura();
        }
        // Durante 'transmitindo' e 'sucesso': ignorar Escape
        return;
      }
      if (this.mostrarDialogoImpressaoFatura) {
        ev.preventDefault();
        this.mostrarDialogoImpressaoFatura = false;
        return;
      }
      if (this.mostrarDialogoFatura) {
        ev.preventDefault();
        this.fecharDialogoFatura();
        return;
      }
      if (this.mostrarDialogPagamento) {
        // Escape no dialog de pagamento e gerenciado pelo FormaPagamentoDialogComponent
        return;
      }
      if (this.mostrarDialogVarianteModificador) {
        ev.preventDefault();
        this.fecharDialogVarianteModificador();
        return;
      }
      // Importar pedido tem prioridade: e o dialog aberto por cima de tudo na tela vazia.
      if (this.mostrarDialogImportarPedido) {
        ev.preventDefault();
        this.mostrarDialogImportarPedido = false;
        return;
      }
      if (this.mostrarDialogObservacaoItem) {
        ev.preventDefault();
        this.mostrarDialogObservacaoItem = false;
        return;
      }
      if (this.mostrarDialogRemoverItem) {
        ev.preventDefault();
        this.cancelarRemocaoItem();
        return;
      }
      if (this.mostrarDialogLimparCarrinho) {
        ev.preventDefault();
        this.fecharDialogLimparCarrinho();
        return;
      }
      if (this.mostrarDialogDesconto) {
        ev.preventDefault();
        this.cancelarDesconto();
        return;
      }
      if (this.mostrarDialogPreco) {
        ev.preventDefault();
        this.cancelarNovoPreco();
        return;
      }
      if (this.mostrarDialogNovoCliente) {
        ev.preventDefault();
        this.mostrarDialogNovoCliente = false;
        return;
      }
      if (this.mostrarDialogAtalhos) {
        ev.preventDefault();
        this.mostrarDialogAtalhos = false;
        return;
      }
      if (this.mostrarDialogDadosClienteNfe) {
        ev.preventDefault();
        this.fecharDialogDadosClienteNfe();
        return;
      }
      return;
    }

    // --- T: retransmitir NFe (dialog de transmissao com erro) ---
    if (ev.key === 't' || ev.key === 'T') {
      if (this.mostrarDialogoTransmissao && this.transmissaoEstado === 'erro') {
        ev.preventDefault();
        this.retransmitirNfe();
        return;
      }
    }

    // --- Enter: confirmar acoes dentro de dialogs ---
    if (ev.key === 'Enter') {
      // Dialog de observacao do item: Enter quebra linha no textarea; Ctrl+Enter = salvar
      if (this.mostrarDialogObservacaoItem) {
        if (ev.ctrlKey) {
          ev.preventDefault();
          this.salvarObservacaoItem();
        }
        return;
      }
      // Dialog de transmissao (estado erro): Enter = ver detalhes da fatura
      if (this.mostrarDialogoTransmissao && this.transmissaoEstado === 'erro') {
        ev.preventDefault();
        this.irParaDetalhesFatura();
        return;
      }
      // Dialog de fatura pos-venda: Enter = nova venda
      // Guard: ignorar Enter nos primeiros 600ms apos abertura do dialog de fatura,
      // para evitar que Enter residual do pagamento feche o dialog imediatamente.
      if (this.mostrarDialogoFatura) {
        const tempoDesdeAbertura = Date.now() - this.dialogFaturaAbertoEm;
        if (tempoDesdeAbertura < 600) {
          ev.preventDefault();
          return;
        }
        ev.preventDefault();
        this.novaVendaDialog();
        return;
      }
      // Dialog de remocao de item: Enter = confirmar
      if (this.mostrarDialogRemoverItem) {
        ev.preventDefault();
        this.confirmarRemocaoItemFinal();
        return;
      }
      // Com o popup de importar pedido aberto, o Enter e dele (confirmar a importacao): deixar o
      // atalho da venda passar dispararia acao no carrinho por tras do dialog.
      if (this.mostrarDialogImportarPedido) {
        return;
      }
      // Dialog de limpar carrinho: Enter = confirmar
      if (this.mostrarDialogLimparCarrinho) {
        ev.preventDefault();
        this.confirmarLimparCarrinho();
        return;
      }
      // Dialog de desconto: Enter = aplicar (se nao estiver em dropdown)
      if (this.mostrarDialogDesconto && this.tipoDeDesconto) {
        ev.preventDefault();
        this.aplicarDesconto();
        return;
      }
      // Dialog de variantes/modificadores: Enter = confirmar (se valido)
      if (this.mostrarDialogVarianteModificador && this.podeConfirmarVarianteModificador) {
        ev.preventDefault();
        this.confirmarSelecaoVarianteModificador();
        return;
      }
      // Dialog de pagamento: Enter gerenciado pelo FormaPagamentoDialogComponent
    }

    // --- F2: focar busca ou nova venda (context-aware) ---
    if (ev.key === 'F2') {
      ev.preventDefault();
      if (this.mostrarDialogoFatura) {
        this.novaVendaDialog();
      } else if (this.nenhumDialogAberto()) {
        setTimeout(() => {
          this.searchInputRef?.nativeElement?.focus();
          this.cdRef.detectChanges();
        }, 100);
      }
      return;
    }

    // --- F3: abrir seletor de clientes ---
    if (ev.key === 'F3') {
      ev.preventDefault();
      this.clienteSelector?.openDialog();
      return;
    }

    // --- F4: focar campo de observacao ---
    if (ev.key === 'F4') {
      ev.preventDefault();
      if (this.nenhumDialogAberto()) {
        setTimeout(() => {
          this.observacaoInput?.nativeElement?.focus();
          this.cdRef.detectChanges();
        }, 100);
      }
      return;
    }

    // --- F7: focar e expandir dropdown de timbrado ---
    if (ev.key === 'F7') {
      ev.preventDefault();
      if (this.nenhumDialogAberto()) {
        setTimeout(() => {
          this.timbradoDD?.focus();
          this.timbradoDD?.show();
          this.cdRef.detectChanges();
        }, 100);
      }
      return;
    }

    // --- F8: abrir dialog de cotacao (global) ---
    if (ev.key === 'F8') {
      ev.preventDefault();
      if (this.nenhumDialogAberto()) {
        this.cotacaoDialogService.abrirDialog();
      }
      return;
    }

    // --- F9: abrir dialog de novo cliente ---
    if (ev.key === 'F9') {
      ev.preventDefault();
      this.abrirDialogNovoCliente();
      return;
    }

    // --- F10: abrir dialog de importar pedido ---
    // O preventDefault vem antes da guarda porque no Firefox o F10 abre a barra de menu; mesmo
    // quando o atalho nao se aplica, deixar o navegador reagir tira o foco da tela de venda.
    if (ev.key === 'F10') {
      ev.preventDefault();
      // Espelha o *ngIf do botao: so da para puxar pedido com o carrinho vazio e com permissao.
      if (this.nenhumDialogAberto() && this.carrinho.length === 0 && this.podeImportarPedido) {
        this.abrirImportarPedido();
      }
      return;
    }

    // --- Ctrl+P: imprimir fatura (quando dialog de fatura aberto) ---
    if (ev.ctrlKey && (ev.key === 'p' || ev.key === 'P')) {
      if (this.mostrarDialogoFatura && !this.carregandoFatura) {
        ev.preventDefault();
        this.gerarPdfFaturaDialog();
        return;
      }
      // Fora do dialog de fatura, nao interceptar (deixar impressao do navegador)
    }

    // --- Ctrl+S: salvar novo cliente (quando dialog aberto) ---
    if (ev.ctrlKey && (ev.key === 's' || ev.key === 'S')) {
      if (this.mostrarDialogNovoCliente) {
        ev.preventDefault();
        this.pessoaDialog?.submitExterno();
        return;
      }
      // Fora do dialog, nao interceptar
    }

    // --- Ctrl+Shift+Delete: limpar carrinho ---
    if (ev.ctrlKey && ev.shiftKey && ev.key === 'Delete') {
      if (this.nenhumDialogAberto() && this.carrinho.length > 0) {
        ev.preventDefault();
        this.abrirConfirmacaoCancelarPedido();
        return;
      }
    }

    // --- Ctrl+Enter: finalizar pedido (quando nenhum dialog de pagamento aberto) ---
    if (!this.mostrarDialogPagamento && ev.key === 'Enter' && ev.ctrlKey) {
      ev.preventDefault();
      this.finalizarPedido();
      return;
    }

    // --- Ctrl+D: abrir dialog de desconto ---
    if (ev.ctrlKey && (ev.key === 'd' || ev.key === 'D')) {
      ev.preventDefault();
      this.abrirDialogDescontoHotkey();
      return;
    }

    // --- Alt+Right / Alt+Left: paginacao de produtos ---
    if (ev.altKey && ev.key === 'ArrowRight') {
      if (this.nenhumDialogAberto()) {
        ev.preventDefault();
        if (this.paginaAtual < this.totalPaginas - 1) {
          this.paginaAtual++;
          if (this.categoriaSelecionada?.id) {
            this.carregarPorGrupo(this.paginaAtual);
          } else {
            this.carregarProdutos(this.paginaAtual);
          }
        }
        return;
      }
    }
    if (ev.altKey && ev.key === 'ArrowLeft') {
      if (this.nenhumDialogAberto()) {
        ev.preventDefault();
        if (this.paginaAtual > 0) {
          this.paginaAtual--;
          if (this.categoriaSelecionada?.id) {
            this.carregarPorGrupo(this.paginaAtual);
          } else {
            this.carregarProdutos(this.paginaAtual);
          }
        }
        return;
      }
    }

    // --- Ctrl+H: toggle mostrar itens sem saldo ---
    if (ev.ctrlKey && (ev.key === 'h' || ev.key === 'H')) {
      if (this.nenhumDialogAberto()) {
        ev.preventDefault();
        this.mostrarSemSaldo = !this.mostrarSemSaldo;
        this.onToggleSemSaldo();
        return;
      }
    }
  }

  /** Verifica se nenhum dialog modal esta aberto (util para atalhos globais) */
  private nenhumDialogAberto(): boolean {
    return !this.mostrarDialogPagamento
      && !this.mostrarDialogDesconto
      && !this.mostrarDialogPreco
      && !this.mostrarDialogNovoCliente

      && !this.mostrarDialogRemoverItem
      && !this.mostrarDialogObservacaoItem
      && !this.mostrarDialogoFatura
      && !this.mostrarDialogoImpressaoFatura
      && !this.mostrarDialogAtalhos
      && !this.mostrarDialogImportarPedido
      && !this.mostrarDialogDadosClienteNfe;
  }

  /** Abre o dialog de atalhos de teclado */
  abrirDialogAtalhos(): void {
    this.mostrarDialogAtalhos = true;
  }

  ngOnInit(): void {
    this.idEmpresa = sessionStorage.getItem('id') || '';
    this.carrinhoService.setCacheScope(this.idEmpresa);
    this.dataAtualFormatada = this.formatarDataAtual();

    // Configuracao do entity-selector para cliente
    // showAddInDropdown somente se o usuario tiver permissao de cadastrar clientes
    this.clienteSelectorConfig = {
      categoryFilter: 'categoriaCliente=true',
      placeholder: this.translate.instant('vendas.placeholders.selecione'),
      showAddButton: false,
      showAddInDropdown: this.permissaoService.temPermissao('cliente'),
      dialogTitle: this.translate.instant('vendas.dialogs.selecao_de_cliente'),
      dialogSubtitle: this.translate.instant('vendas.dialogs.selecao_de_cliente_desc'),
      dialogIcon: 'pi pi-users',
    };

    this.temPermissaoConfiguracao = this.permissaoService.temPermissao('configuracao');

    this.montarCodigoOptions();
    this.carregarPreferenciaDeCodigo();

    this.carrinhoService.refreshFromCache();
    this.carregarPadroesDaEmpresa();
    this.carregarVendedorPessoaId();

    this.carregarClientes();
    this.carregarGrupos();
    this.carregarProdutos();
    this.carregarContas();
    this.carregarContasTarjetaQrcode();
    this.carregarContaDoQrCode();
    this.carregarTimbrados();

    this.restaurarCache();

    if (!this.observacao) {
      this.observacao = '';
    }

    // Pipeline de busca incremental com switchMap para cancelar requests obsoletas.
    // Sem switchMap, digitar "2*410" dispara uma request vazia (quando o termo
    // intermediario "2*" vira "" apos extrairTermoFiltro) e uma filtrada para "410";
    // se a vazia responde por ultimo, sobrescreve os resultados filtrados.
    this.termoBusca$
      .pipe(
        debounceTime(1000),
        // Strip do prefixo "<qtd>*" para o filtro reativo: usuario digitando
        // "2*408" deve filtrar pelo codigo "408" no grid (multiplicador eh
        // aplicado apenas no Enter via executarBuscaComMultiplicador).
        map((termo) => this.extrairTermoFiltro(termo)),
        tap((termo) => {
          this.termoFiltroAtual = termo;
          this.loading = true;
          this.produtoNaoEncontrado = false;
        }),
        // switchMap cancela automaticamente a request anterior quando um novo
        // termo chega antes da resposta HTTP, eliminando a race condition.
        // catchError dentro do switchMap impede que erros HTTP encerrem o stream
        // externo: converte o erro em uma emissao de "busca vazia" para que o
        // next handler siga o caminho normal de "nao encontrado".
        switchMap((termo) => this.buildBuscaComFallback(termo)),
      )
      .subscribe({
        next: (res) => {
          // res pode ser { tipo: 'busca', content: Page } ou { tipo: 'listagem', content: Page }
          if (res.tipo === 'busca') {
            let lista = Array.isArray(res.content?.content) ? res.content.content : [];
            // Filtrar por categoria ativa, se houver (grupo é objeto aninhado no DTO, usar matchGrupo)
            if (this.categoriaSelecionada?.id && lista.length) {
              lista = lista.filter((p: any) => this.matchGrupo(p));
            }
            if (!lista.length) {
              this.produtosBrutos = [];
              this.produtos = [];
              this.produtoNaoEncontrado = true;
            } else {
              this.produtoNaoEncontrado = false;
              this.produtosBrutos = lista;
              this.aplicarFiltroSemSaldo();
              this.autoAdicionarPorCodigoDeBarras(this.termoFiltroAtual, lista);
            }
          } else {
            // tipo === 'listagem' (termo vazio — branch de carregarProdutos / carregarPorGrupo)
            const page = res.content;
            this.produtosBrutos = page.content;
            this.sortProdutosByCodigoAsc();
            this.totalPaginas = page.totalPages;
            this.totalElements = page.totalElements ?? (page.totalPages * this.tamanhoPagina);
            this.aplicarFiltroSemSaldo();
            if (this.produtos.length === 0) {
              this.produtoNaoEncontrado = true;
            } else {
              this.produtoNaoEncontrado = false;
            }
            // Revalidar saldos do cache somente na primeira carga via pipeline (equiv. a carregarProdutos)
            if (!this.cacheRevalidado && !this.categoriaSelecionada?.id) {
              this.cacheRevalidado = true;
              this.revalidarSaldosDoCache();
            }
          }
          this.loading = false;
        },
        error: () => {
          // Este handler so e alcancado se um erro escapar do catchError interno,
          // o que nao deveria acontecer. Mantido como ultima linha de defesa.
          console.warn('[vendas] erro inesperado no pipeline de busca — stream encerrado');
          this.produtosBrutos = [];
          this.produtos = [];
          this.produtoNaoEncontrado = true;
          this.loading = false;
        },
      });

    this.translate.onLangChange.subscribe(() => {
      this.timbrados = [...this.timbrados];
      if (this.observacao === this.translate.instant('Observacao')) {
        this.observacao = '';
      }
      // Atualizar label "Todas" no array de grupos e na categoria selecionada quando idioma muda
      const labelTodas = this.translate.instant('vendas.labels.todas_categorias');
      if (this.grupos.length > 0 && this.grupos[0].id === null) {
        this.grupos[0].nome = labelTodas;
        this.grupos = [...this.grupos];
      }
      if (!this.categoriaSelecionada.id) {
        this.categoriaSelecionada = { ...this.categoriaSelecionada, nome: labelTodas };
      }
      this.cdRef.detectChanges();
    });

    // Carregar cotacao atual para conversoes de moeda
    setTimeout(() => this.carregarCotacaoAtual(), 1000);

    // Escutar quando cotacao global for salva para atualizar valores locais
    this.cotacaoDialogService.cotacaoSalva$.subscribe(valores => {
      this.cotPYG = valores.dolarGuarani || 7180;
      this.cotBRL = valores.dolarReal || 5.47;
      this.cotPesoGuarani = valores.pesoGuarani || 0;
      this.cotRealGuarani = (valores as any).realGuarani || 0;
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.searchInputRef?.nativeElement?.focus(), 0);
  }

  private labelTipoPadraoNota(code: keyof typeof TipoPadraoNota | string): string {
    const raw = this.translate.instant(`enums.tipo_padrao_nota.${code}`);
    return raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
  }

  /* ------------ UI helpers ------------ */
  getDialogStyle() {
    if (this.formaPagamentoSelecionada === 'dinheiro') {
      return { width: '940px', height: 'auto', 'max-height': '95vh', 'margin-top': '0' };
    }
    return { width: '555px', height: 'auto', 'max-height': '95vh', 'margin-top': '0' };
  }

  ehServico(p: any): boolean {
    const tip = p?.tipoItem;
    const codigo = typeof tip === 'string' ? tip : tip?.enum;
    return codigo === 'SERVICO';
  }
  indisponivel(p: any): boolean {
    if (this.ehServico(p)) return false;
    const saldo = Number(p?.saldo ?? 0);
    return saldo <= 0;
  }
  podeClicar(p: any): boolean {
    return this.ehServico(p) || !this.indisponivel(p);
  }

  /**
   * Verifica se o item pertence à categoria selecionada.
   * O backend retorna o grupo como objeto aninhado (grupo.id), não como campo flat (grupo_id).
   * A forma defensiva suporta ambas as representações caso o endpoint mude.
   */
  private matchGrupo(item: any): boolean {
    const idDoGrupo = item?.grupo?.id ?? item?.grupo_id;
    return Number(idDoGrupo) === Number(this.categoriaSelecionada.id);
  }

  /* ------------ Busca/Listas ------------ */
  onInputChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    const termo = target.value;
    this.termoBrutoAtual = termo;
    this.codigoJaAutoAdicionado = '';
    this.termoBusca$.next(termo);
  }

  onSearchEnter(ev: Event): void {
    const input = ev.target as HTMLInputElement | null;
    const termo = (input?.value || '').trim();
    if (!termo) return;

    // Codigo de barras ja resolvido pela adicao automatica: o Enter so limpa o
    // campo, senao o item entraria duas vezes.
    if (this.extrairTermoFiltro(termo) === this.codigoJaAutoAdicionado) {
      if (input) input.value = '';
      this.codigoJaAutoAdicionado = '';
      return;
    }

    // Curto-circuito: se o termo for "<qtd>*<codigo>", tenta tratar como multiplicador
    // antes de cair no fluxo padrao. Se nao casar 1:1, segue o fluxo normal.
    const multiplicador = this.parseMultiplicador(termo);
    if (multiplicador) {
      this.executarBuscaComMultiplicador(multiplicador.codigo, multiplicador.quantidade, input);
      return;
    }

    this.produtosService.buscarPorNomeOuBarras(termo).subscribe({
      next: (res) => {
        const lista = res?.content ?? [];
        const encontrado = lista.find((p: any) =>
          String(p?.codigoItem ?? '').toLowerCase() === termo.toLowerCase() ||
          String(p?.barras ?? '').toLowerCase() === termo.toLowerCase()
        );

        if (encontrado) {
          this.adicionarProduto(encontrado);
          const summary = this.translate.instant('vendas.toast.adicionado');
          const detail  = this.translate.instant('vendas.toast.produto_adicionado', {
            produto: encontrado?.nome ?? '',
            producto: encontrado?.nome ?? ''
          });
          this.messageService.add({ severity: 'success', summary, detail });

          if (input) input.value = '';
          this.produtoNaoEncontrado = false;
          this.paginaAtual = 0;

          if (this.categoriaSelecionada?.id) this.carregarPorGrupo();
          else this.carregarProdutos();
        } else {
          this.produtosBrutos = [];
          this.produtos = [];
          this.produtoNaoEncontrado = true;
          this.loading = false;
        }
      },
      error: () => {
        this.produtosBrutos = [];
        this.produtos = [];
        this.produtoNaoEncontrado = true;
        this.loading = false;
      }
    });
  }

  /**
   * Faz parse do padrao "<quantidade>*<codigo>" digitado no campo de busca.
   * Aceita apenas digitos antes do `*` e qualquer sequencia alfanumerica depois (codigoItem ou barras).
   * Retorna `null` se o termo nao casar exatamente com o padrao.
   */
  private parseMultiplicador(termo: string): { quantidade: number; codigo: string } | null {
    const match = /^(\d+)\*(\w+)$/.exec(termo);
    if (!match) return null;
    const quantidade = parseInt(match[1], 10);
    const codigo = match[2];
    if (!Number.isFinite(quantidade) || quantidade < 1 || !codigo) return null;
    return { quantidade, codigo };
  }

  /**
   * Para a busca incremental: remove o prefixo "<digitos>*" do termo digitado
   * (multiplicador parcial/completo) para que o backend filtre apenas pela
   * parte util (codigo/nome). Strip ocorre somente quando o que precede o
   * primeiro `*` eh vazio ou apenas digitos; caso contrario, retorna o termo
   * cru (preserva busca por nomes que contenham `*`).
   */
  private extrairTermoFiltro(termo: string): string {
    if (!termo) return termo;
    const m = termo.match(/^\d*\*(.*)$/);
    return m ? m[1] : termo;
  }

  /**
   * Busca o produto pelo codigo e, se houver match exato unico (codigoItem ou barras),
   * adiciona ao carrinho com a quantidade indicada. Caso contrario, cai no fluxo padrao
   * (lista vazia + estado "nao encontrado" / lista completa, conforme a resposta).
   */
  private executarBuscaComMultiplicador(codigo: string, quantidade: number, input: HTMLInputElement | null): void {
    this.produtosService.buscarPorNomeOuBarras(codigo).subscribe({
      next: (res) => {
        const lista = res?.content ?? [];
        const totalElements = Number(res?.totalElements ?? lista.length);
        const codigoLower = codigo.toLowerCase();

        // Quando há categoria selecionada, aplicar o mesmo filtro client-side que buscarProdutos usa.
        // grupo é objeto aninhado no ItemConsultaDTO (grupo.id), não campo flat — usar matchGrupo.
        const listaFiltrada = this.categoriaSelecionada?.id
          ? lista.filter((p: any) => this.matchGrupo(p))
          : lista;

        const matches = listaFiltrada.filter((p: any) =>
          String(p?.codigoItem ?? '').toLowerCase() === codigoLower ||
          String(p?.barras ?? '').toLowerCase() === codigoLower
        );

        // Quando há categoria: "item solo" é baseado na lista filtrada (não em totalElements do backend).
        // Quando não há categoria: mantém o comportamento original com totalElements.
        const encontradoSolo = this.categoriaSelecionada?.id
          ? (matches.length === 0 && listaFiltrada.length === 1 ? listaFiltrada[0] : null)
          : (matches.length === 0 && totalElements === 1 ? lista[0] : null);

        // Backend retornou o item mas ele está fora da categoria selecionada.
        if (lista.length > 0 && listaFiltrada.length === 0 && this.categoriaSelecionada?.id) {
          this.messageService.add({
            severity: 'warn',
            summary: this.translate.instant('common.atencao'),
            detail: this.translate.instant('vendas.mensagens.fora_categoria'),
          });
          if (input) input.value = '';
          return;
        }

        // Prioridade: 1 match exato > item solo > fluxo padrao.
        if (matches.length === 1 || encontradoSolo) {
          const encontrado = matches.length === 1 ? matches[0] : encontradoSolo;

          // Validar disponibilidade antes de adicionar (produto com saldo 0)
          if (!this.ehServico(encontrado) && this.indisponivel(encontrado)) {
            this.messageService.add({
              severity: 'warn',
              summary: this.translate.instant('vendas.mensagens.indisponivel'),
              detail: this.translate.instant('vendas.mensagens.produto_indisponivel'),
            });
            if (input) input.value = '';
            return;
          }

          // Passar quantidade original para adicionarProduto; o clamp e o warn de saldo
          // ficam centralizados em adicionarProdutoComPreco para evitar duplicidade de toast.
          // Calcular quantidadeEfetiva apenas para exibir a quantidade real no toast verde.
          const saldoDisponivel = Number(encontrado?.saldo ?? 0);
          const isServico = this.ehServico(encontrado);
          const quantidadeEfetiva = isServico ? quantidade : Math.min(quantidade, saldoDisponivel);

          this.adicionarProduto(encontrado, quantidade);

          const summary = this.translate.instant('vendas.toast.adicionado');
          const detail  = this.translate.instant('vendas.toast.produto_adicionado_qtd', {
            quantidade: quantidadeEfetiva,
            produto: encontrado?.nome ?? '',
            producto: encontrado?.nome ?? ''
          });
          this.messageService.add({ severity: 'success', summary, detail });

          if (input) input.value = '';
          this.produtoNaoEncontrado = false;
          this.paginaAtual = 0;

          if (this.categoriaSelecionada?.id) this.carregarPorGrupo();
          else this.carregarProdutos();
          return;
        }

        // Nao houve match exato unico: abrir dialog de selecao com a lista filtrada.
        // Usa listaFiltrada para respeitar o filtro de categoria quando aplicavel.
        if (listaFiltrada.length === 0) {
          this.produtoNaoEncontrado = true;
          this.messageService.add({
            severity: 'warn',
            summary: this.translate.instant('vendas.mensagens.nao_encontrado'),
            detail: this.translate.instant('vendas.mensagens.produto_nao_encontrado'),
          });
          if (input) input.value = '';
        } else {
          // No dialog do multiplicador itens sem saldo nunca aparecem, independente do checkbox.
          // Servicos nao possuem estoque e por isso nunca sao filtrados por saldo.
          const itensParaDialog = listaFiltrada.filter((item: any) =>
            this.ehServico(item) || Number(item?.saldo ?? 0) > 0
          );

          if (itensParaDialog.length === 0) {
            // Backend retornou itens mas todos foram ocultados pelo filtro de saldo.
            // Abordagem simples: mostrar warn e pedir para o usuario desmarcar o filtro.
            this.messageService.add({
              severity: 'warn',
              summary: this.translate.instant('common.atencao'),
              detail: this.translate.instant('vendas.mensagens.todos_indisponiveis'),
            });
            if (input) input.value = '';
          } else if (itensParaDialog.length === 1) {
            // Apos filtro de saldo sobrou apenas 1 item: adicionar direto, sem abrir dialog para escolher um unico item.
            this.adicionarProduto(itensParaDialog[0], quantidade);
            if (input) input.value = '';
          } else {
            // Setar estado do dialog e abrir.
            // Nao popula `produtosBrutos` (grid permanece como estava — dialog eh modal).
            this.itensDialogSelecao = itensParaDialog;
            this.quantidadeDialogSelecao = quantidade;
            this.codigoDialogSelecao = codigo;
            this.paginaAtualDialog = 0;
            this.mostrarDialogSelecaoMultiplicador = true;
            this.produtoNaoEncontrado = false;
            if (input) input.value = '';
          }
        }
        this.loading = false;
      },
      error: () => {
        this.produtosBrutos = [];
        this.produtos = [];
        this.produtoNaoEncontrado = true;
        this.loading = false;
      }
    });
  }

  private aplicarFiltroSemSaldo(): void {
    this.produtos = this.mostrarSemSaldo
      ? [...this.produtosBrutos]
      : this.produtosBrutos.filter((p) => this.ehServico(p) || !this.indisponivel(p));
  }

  /**
   * Aplica o mesmo filtro de saldo de `aplicarFiltroSemSaldo` em uma lista arbitraria,
   * sem mexer em `produtos`/`produtosBrutos`. Usado pelo dialog de selecao do multiplicador
   * para reaproveitar a regra do checkbox `mostrarSemSaldo` sem afetar o grid.
   */
  private aplicarFiltroSemSaldoEm(lista: any[]): any[] {
    return this.mostrarSemSaldo
      ? [...lista]
      : lista.filter((p) => this.ehServico(p) || !this.indisponivel(p));
  }

  onToggleSemSaldo(): void {
    this.aplicarFiltroSemSaldo();
    this.salvarCache();
  }

  // ---------------------------------------------------------------------------
  // Exibicao do codigo (card da grade e linha do carrinho)
  // ---------------------------------------------------------------------------

  private montarCodigoOptions(): void {
    this.codigoOptions = [
      { label: this.translate.instant('vendas.labels.codigo_nenhum'), value: 'NENHUM' },
      { label: this.translate.instant('vendas.labels.codigo_interno'), value: 'CODIGO' },
      { label: this.translate.instant('vendas.labels.codigo_barras'), value: 'BARRAS' },
    ];
  }

  private carregarPreferenciaDeCodigo(): void {
    try {
      const salvo = localStorage.getItem(this.STORAGE_CODIGO) as ExibicaoCodigo | null;
      if (salvo === 'NENHUM' || salvo === 'CODIGO' || salvo === 'BARRAS') {
        this.exibicaoCodigo = salvo;
      }
    } catch (e) {
      console.warn('Erro ao carregar preferencia de exibicao de codigo:', e);
    }
  }

  onExibicaoCodigoChange(): void {
    try {
      localStorage.setItem(this.STORAGE_CODIGO, this.exibicaoCodigo);
    } catch (e) {
      console.warn('Erro ao salvar preferencia de exibicao de codigo:', e);
    }
  }

  /**
   * Texto do codigo sob o nome. Null quando nao ha o que mostrar (escolha
   * NENHUM, ou item sem o codigo escolhido) — o template nem renderiza a linha.
   */
  textoDoCodigo(item: any, modo: ExibicaoCodigo): string | null {
    if (!item || modo === 'NENHUM') return null;
    if (modo === 'BARRAS') {
      const barras = String(item.barras ?? '').trim();
      return barras || null;
    }
    const codigo = item.codigoItem;
    if (codigo == null || String(codigo).trim() === '') return null;
    return `${this.translate.instant('vendas.table.cod')} ${codigo}`;
  }

  /**
   * Codigo de barras colado (ou bipado) na busca: o item entra no carrinho sem
   * clique e sem Enter. So dispara com UM resultado cujo campo `barras` e
   * exatamente o termo — com dois ou mais, ou casando por nome, a escolha
   * continua sendo do operador.
   *
   * Passa pelo mesmo `adicionarProduto()` do clique no card, entao item com
   * variantes/modificadores continua abrindo o dialog de personalizacao. Apos
   * adicionar, o campo de busca e limpo e o foco volta para ele, para o
   * operador poder bipar o proximo codigo em sequencia.
   */
  private autoAdicionarPorCodigoDeBarras(termo: string, lista: any[]): void {
    const t = (termo || '').trim();
    if (!t || t === this.codigoJaAutoAdicionado) return;
    if (!Array.isArray(lista) || lista.length !== 1) return;

    const produto = lista[0];
    const barras = String(produto?.barras ?? '').trim();
    if (!barras || barras.toLowerCase() !== t.toLowerCase()) return;
    if (!this.podeClicar(produto)) return;

    // "3*<codigo de barras>": a quantidade vem do termo ORIGINAL, e o clamp por
    // saldo fica com `adicionarProduto` (adicionarProdutoComPreco), que ja avisa
    // quando o pedido passa do estoque.
    const multiplicador = this.parseMultiplicador(this.termoBrutoAtual);
    const pedida = multiplicador?.quantidade ?? 1;
    const saldoDisponivel = Number(produto?.saldo ?? 0);
    const efetiva = this.ehServico(produto) ? pedida : Math.min(pedida, saldoDisponivel);

    this.codigoJaAutoAdicionado = t;
    this.adicionarProduto(produto, pedida);
    this.messageService.add({
      severity: 'success',
      summary: this.translate.instant('vendas.toast.adicionado'),
      detail: efetiva > 1
        ? this.translate.instant('vendas.toast.produto_adicionado_qtd', {
            quantidade: efetiva,
            produto: produto?.nome ?? '',
            producto: produto?.nome ?? '',
          })
        : this.translate.instant('vendas.toast.produto_adicionado', {
            produto: produto?.nome ?? '',
            producto: produto?.nome ?? '',
          }),
    });

    // Quando `adicionarProduto` (com variantes/modificadores em cache, ou preco
    // zero) ja abriu um dialog de personalizacao de forma sincrona, NAO limpar
    // nem devolver o foco: roubaria o foco do dialog que acabou de abrir.
    if (this.mostrarDialogVarianteModificador || this.mostrarDialogPreco) return;

    // Limpa a busca e devolve o foco: quem bipou/colou um codigo quer bipar o
    // proximo em seguida, sem o termo anterior sobrando no campo nem filtrando a grade.
    this.limparBuscaAposAutoAdicao();
  }

  /**
   * Reseta o campo de busca e a listagem apos uma adicao automatica por codigo
   * de barras (colado/bipado). Mesmo padrao usado no sucesso de `onSearchEnter`
   * e `executarBuscaComMultiplicador`, mas tambem devolve o foco ao input, ja
   * que aqui nao houve Enter para mante-lo la.
   */
  private limparBuscaAposAutoAdicao(): void {
    this.termoBrutoAtual = '';
    this.termoFiltroAtual = '';
    this.codigoJaAutoAdicionado = '';
    this.produtoNaoEncontrado = false;
    this.paginaAtual = 0;

    if (this.searchInputRef?.nativeElement) {
      this.searchInputRef.nativeElement.value = '';
    }

    if (this.categoriaSelecionada?.id) this.carregarPorGrupo();
    else this.carregarProdutos();

    setTimeout(() => this.searchInputRef?.nativeElement?.focus(), 0);
  }

  /**
   * Item selecionado no dialog do multiplicador.
   * Fecha o dialog ANTES de chamar `adicionarProduto` para evitar cascata de modais
   * sobrepostos (dialog de preco zero / variantes pode abrir em sequencia).
   */
  selecionarItemDoDialog(item: any): void {
    const qtd = this.quantidadeDialogSelecao;
    // Fecha e limpa estado ANTES de adicionar (cascata sequencial, nao sobreposta)
    this.mostrarDialogSelecaoMultiplicador = false;
    this.itensDialogSelecao = [];
    this.quantidadeDialogSelecao = 0;
    this.codigoDialogSelecao = '';
    this.paginaAtualDialog = 0;
    this.adicionarProduto(item, qtd);
    // Volta foco ao input de busca
    setTimeout(() => this.searchInputRef?.nativeElement?.focus(), 0);
  }

  /** Cancela o dialog de selecao do multiplicador (Esc / botao Cancelar). */
  cancelarDialogSelecaoMultiplicador(): void {
    this.mostrarDialogSelecaoMultiplicador = false;
    this.itensDialogSelecao = [];
    this.quantidadeDialogSelecao = 0;
    this.codigoDialogSelecao = '';
    this.paginaAtualDialog = 0;
    setTimeout(() => this.searchInputRef?.nativeElement?.focus(), 0);
  }

  /** Handler do <p-paginator> do dialog de selecao do multiplicador. */
  onPaginaDialogChange(event: { first?: number; rows?: number; page?: number }): void {
    this.paginaAtualDialog = event.page ?? 0;
  }

  /* ------------ Vendedor ------------ */
  private carregarVendedorPessoaId(): void {
    const usuarioId = sessionStorage.getItem('userId');
    if (!usuarioId) return;
    this.usuarioService.get(`/usuario/${usuarioId}`).subscribe({
      next: (res: any) => {
        this.vendedorPessoaId = res?.pessoa?.id || null;
      },
      error: () => {
        console.warn('[Venda] Não foi possível obter vendedorPessoaId');
      }
    });
  }

  /* ------------ Config empresa ------------ */
  carregarPadroesDaEmpresa(): void {
    if (!this.idEmpresa) return;

    this.empresaConfigService.get(`/configuracaoEmpresa/${this.idEmpresa}`).subscribe({
      next: (res) => {
        const moeda = res?.moeda;
        const codigoOperacao =
        moeda?.codigoOperacao ??
        (moeda?.enum === 'REAL' ? 'BRL' : moeda?.enum === 'DOLAR' ? 'USD' : 'PYG');

        this.moedaPadrao = (codigoOperacao as 'BRL' | 'PYG' | 'USD' | 'ARS');

        const rawLocal = moeda?.pais?.local || 'pt_BR';
        this.localeMoeda = String(rawLocal).replace('_', '-');

        const casas = Number(moeda?.casasDecimais ?? (codigoOperacao === 'PYG' ? 0 : 2));
        this.digitsMoeda = casas === 0 ? '1.0-0' : '1.2-2';

        const clientePadrao = res?.clientePadrao;
        this.clientePadraoId = clientePadrao?.id ?? null;

        const timbradoPadrao = res?.timbradoPadraoVenda;
        this.timbradoPadraoId = timbradoPadrao?.id ?? null;
        this.timbradoPadraoLabel =
          timbradoPadrao?.tipoNota?.enum ??
          timbradoPadrao?.tipoNota ??
          'VENDA_COMUM';

        // seleciona a linha padrão da moeda para o highlight
        this.selectedMoneyCode = (this.moedaPadrao as any) || 'BRL';

        // Pre-seleciona formato de impressao da configuracao da empresa
        const formatoImpressao = res?.tipoDeFormatoDaImpressao?.enum
          ?? res?.tipoDeFormatoDaImpressao;
        if (formatoImpressao === 'BOBINA_58' || formatoImpressao === 'BOBINA_80' || formatoImpressao === 'A4') {
          this.opcaoImpressaoFatura = formatoImpressao;
        } else {
          this.opcaoImpressaoFatura = 'BOBINA_58';
        }

        // Carrega opcao de impressao automatica da empresa
        const rawTipoImprimir = (res as any)?.tipoImprimir;
        this.tipoImprimir = typeof rawTipoImprimir === 'string'
          ? rawTipoImprimir
          : rawTipoImprimir?.tipoEnum ?? rawTipoImprimir?.enum ?? 'PERGUNTAR';

        // Flag "Imprimir ficha do evento" (controla o botao Imprimir Ficha no dialogo)
        this.deveImprimirFicha = (res as any)?.deveImprimirFicha === true;

        // Sem dados de recebimento configurados, a forma QR Code nao gera QR:
        // exibe o aviso e libera apenas a selecao de conta.
        this.bancardConfigurado = res?.bancardConfigurado === true;
        this.contaQrCodeId = res?.minishopContaQrCodeId ?? null;
        this.montarContaDoQrCode();

        this.aplicarClientePadrao();
        this.aplicarTimbradoPadrao();

      },
      error: () => {
        this.moedaPadrao = 'BRL';
        this.localeMoeda = 'pt-BR'; this.digitsMoeda = '1.2-2'; this.timbradoPadraoLabel = 'VENDA_COMUM';
        this.selectedMoneyCode = 'BRL';
        this.opcaoImpressaoFatura = 'BOBINA_58';
        this.deveImprimirFicha = false;
      },
    });
  }

  private aplicarClientePadrao(): void {
    if (!this.clientePadraoId) return;

    const carrinhoTemItens = this.carrinho?.length > 0;

    // Carrinho com itens E cliente já selecionado (vindo do cache) → honrar cache
    if (carrinhoTemItens && this.clienteSelecionado) return;

    // Carrinho vazio OU sem cliente → aplicar padrão empresa
    this.pessoaService.get(`/pessoas/${this.clientePadraoId}`).subscribe(
      (pessoa: any) => {
        if (pessoa) {
          // Verificar novamente no callback: se carrinho foi restaurado com cliente entre o início e a resposta HTTP, honrar cache
          const carrinhoAindaTemItens = this.carrinho?.length > 0;
          if (carrinhoAindaTemItens && this.clienteSelecionado) return;
          this.clienteSelecionado = pessoa;
          this.pessoa_id = pessoa.id;
        }
      },
      () => { /* ignora erro - cliente padrao pode nao existir mais */ }
    );
  }

  private buildVendaComumOption(): TimbradoOption {
    return { value: null, id: -1, label: this.labelTipoPadraoNota('VENDA_COMUM') };
  }

  /** Chamado pelo (onChange) do p-dropdown de timbrado. Sincroniza o objeto completo pelo id selecionado. */
  onTimbradoChange(event: any): void {
    const id: number = event?.value ?? this.timbradoSelecionadoId;
    this.sincronizarTimbradoPorId(id);
    this.salvarCache();
  }

  /** Mantém timbradoSelecionado (objeto) sincronizado com timbradoSelecionadoId (number). */
  private sincronizarTimbradoPorId(id: number): void {
    const found = this.timbrados.find(t => t.id === id);
    this.timbradoSelecionado = found ?? { label: this.labelTipoPadraoNota('VENDA_COMUM'), value: null, id: -1 };
    this.timbradoSelecionadoId = this.timbradoSelecionado.id ?? -1;
  }

  private aplicarTimbradoPadrao(): void {
    if (!this.timbrados?.length) return;

    const carrinhoTemItens = this.carrinho?.length > 0;

    // Carrinho com itens E timbrado cacheado válido → honrar cache
    if (carrinhoTemItens && this.timbradoSelecionado?.id != null && this.timbradoSelecionado.id !== -1) {
      const byId = this.timbrados.find(t => t.id === this.timbradoSelecionado.id);
      const byValueId = this.timbradoSelecionado?.value?.id
                      ? this.timbrados.find(t => t?.value?.id === this.timbradoSelecionado.value.id)
                      : null;
      const resolved = byId || byValueId;
      if (resolved) {
        this.timbradoSelecionado = resolved;
        this.timbradoSelecionadoId = resolved.id ?? -1;
        return;
      }
    }

    // Carrinho vazio OU cache inválido → aplicar padrão empresa
    // 1. Se config tem id específico, buscar pelo id
    if (this.timbradoPadraoId) {
      const foundById = this.timbrados.find(t => t?.value?.id === this.timbradoPadraoId);
      if (foundById) {
        this.timbradoSelecionado = foundById;
        this.timbradoSelecionadoId = foundById.id ?? -1;
        return;
      }
    }
    // 2. Se config é tipo VENDA_COMUM sem id específico, usar o default genérico (id=-1)
    if (this.timbradoPadraoLabel === 'VENDA_COMUM' && !this.timbradoPadraoId) {
      const defaultOpt = this.timbrados.find(t => t.id === -1);
      if (defaultOpt) {
        this.timbradoSelecionado = defaultOpt;
        this.timbradoSelecionadoId = -1;
        return;
      }
    }
    // 3. Se config é outro tipo (ex.: ELETRONICA), buscar pelo tipo
    if (this.timbradoPadraoLabel && this.timbradoPadraoLabel !== 'VENDA_COMUM') {
      const foundByType =
        this.timbrados.find(t => t?.value?.tipoNota?.enum === this.timbradoPadraoLabel);
      if (foundByType) {
        this.timbradoSelecionado = foundByType;
        this.timbradoSelecionadoId = foundByType.id ?? -1;
        return;
      }
    }

    // Fallback: Venda Comum
    const defaultOpt =
      this.timbrados.find(t => t.id === -1) ||
      { label: this.labelTipoPadraoNota('VENDA_COMUM'), value: null, id: -1 };
    this.timbradoSelecionado = defaultOpt;
    this.timbradoSelecionadoId = defaultOpt.id ?? -1;
  }

  carregarTimbrados(): void {
    this.timbradoService.get('/timbrado').subscribe((res) => {
      const timbradosRetornados = (res?.content ?? [])
        .filter((t: any) => {
          const tipo = t?.tipoDeTransacao;
          const tipoEnum = tipo && typeof tipo === 'object' && 'enum' in tipo ? tipo.enum : tipo;
          return tipoEnum === 'VENDA';
        })
        .map((t: any) => ({
          label: (() => {
            const tipoNotaEnum = t?.tipoNota && typeof t.tipoNota === 'object' ? t.tipoNota.enum : (t?.tipoNota ?? '');
            const raw = this.translate.instant(`enums.tipo_padrao_nota.${tipoNotaEnum}`);
            const nomeTipoNota = raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
            const filial = String(t?.numeroFilial ?? '').padStart(3, '0');
            const expedicao = String(t?.pontoDeExpedicao ?? '').padStart(3, '0');
            const numero = String(t?.proximoNumero ?? '').padStart(7, '0');
            return `${nomeTipoNota} - ${filial}-${expedicao}-${numero}`;
          })(),
          value: t,
          id: t?.id ?? null
        }));

      this.timbrados = [
        { label: this.labelTipoPadraoNota('VENDA_COMUM'), value: null, id: -1 },
        ...timbradosRetornados
      ];

      this.aplicarTimbradoPadrao();
    });
  }

  carregarContas(): void {
    this.contaService.get('/conta?tipoConta=BANCO').subscribe({
      next: (res) => {
        if (res?.content && Array.isArray(res.content)) {
          this.contas = res.content.map((conta: any) => ({ label: conta.tituloDaConta, value: conta }));
        } else {
          this.contas = [];
        }
      },
      error: () => (this.contas = []),
    });
  }

  /**
   * Carrega as contas habilitadas para tarjeta/QR Code.
   *
   * Lista vazia e estado valido: o dialogo mostra a orientacao de marcar uma conta
   * na tela de Contas, em vez de um erro.
   */
  carregarContasTarjetaQrcode(): void {
    this.contaService.listarContasTarjetaQrcode().subscribe({
      next: (contas) => {
        this.contasTarjetaQrcode = (contas || []).map((conta: any) => ({
          label: conta.tituloDaConta,
          value: conta,
        }));
      },
      error: () => (this.contasTarjetaQrcode = []),
    });
  }

  /**
   * Carrega as contas de banco em guaranis, para dar nome a conta configurada do QR Code.
   *
   * Sao as unicas elegiveis a receber pela Bancard; a lista chega separada da configuracao
   * (sessao), entao as duas cargas se encontram em `montarContaDoQrCode`.
   */
  private carregarContaDoQrCode(): void {
    this.contaService.listarContasBancariasEmGuarani().subscribe({
      next: (contas) => {
        this.contasBancariasGuarani = contas ?? [];
        this.montarContaDoQrCode();
      },
      error: () => {
        this.contasBancariasGuarani = [];
        this.montarContaDoQrCode();
      },
    });
  }

  /** Junta a conta configurada com a lista, para o dialogo exibir o nome dela. */
  private montarContaDoQrCode(): void {
    const conta = this.contasBancariasGuarani.find((c: any) => c.id === this.contaQrCodeId);
    this.contaQrCode = conta ? { id: conta.id, label: conta.tituloDaConta } : null;
  }

  /**
   * Gera a cobranca por QR Code na Bancard e passa a observar a confirmacao.
   *
   * A venda so e concluida quando o callback da Bancard confirmar o pagamento —
   * ver `iniciarPollingQrCode`.
   */
  onGerarQrCode(): void {
    if (this.estadoQrCode.gerando) return;
    this.estadoQrCode = { gerando: true, confirmado: false };

    const total = this.subtotal - this.descontos;
    this.intencaoDeRecebimentoService
      .gerarQrCode(total, toLocalISOString(new Date()), this.clienteSelecionado?.id ?? null)
      .subscribe({
        next: (intencao) => {
          this.estadoQrCode = {
            gerando: false,
            confirmado: false,
            urlQr: intencao.urlQr,
            qrData: intencao.qrData,
            intencaoId: intencao.id,
          };
          this.iniciarPollingQrCode(intencao.id);
        },
        error: (err) => {
          this.estadoQrCode = { gerando: false, confirmado: false };
          this.messageService.add({
            severity: 'error',
            summary: this.translate.instant('erro'),
            detail: err?.error?.message || this.translate.instant('forma_pagamento.qrcode_erro_gerar'),
          });
        },
      });
  }

  /**
   * Observa a confirmacao do pagamento a cada 5s.
   *
   * Para sozinho depois de 5 minutos para nao ficar batendo no servidor com uma aba
   * esquecida aberta — mesmo criterio do fluxo de contratacao de usuarios.
   */
  private iniciarPollingQrCode(intencaoId: number): void {
    this.pararPollingQrCode();

    this.pollingQrCodeSub = interval(5000)
      .pipe(
        take(60),
        switchMap(() =>
          this.intencaoDeRecebimentoService.consultarStatus(intencaoId).pipe(catchError(() => of(null))),
        ),
      )
      .subscribe((status) => {
        if (!status?.confirmado) return;
        this.pararPollingQrCode();
        this.estadoQrCode = { ...this.estadoQrCode, confirmado: true };
        this.messageService.add({
          severity: 'success',
          summary: this.translate.instant('sucesso'),
          detail: this.translate.instant('forma_pagamento.qrcode_confirmado'),
        });
        this.cdRef.detectChanges();
      });
  }

  private pararPollingQrCode(): void {
    this.pollingQrCodeSub?.unsubscribe();
    this.pollingQrCodeSub = undefined;
  }

  /**
   * Texto de rastreabilidade gravado em `informacaoDaTransacao` da nota.
   *
   * O backend nao tem campos proprios para bandeira/parcelas/cobranca, entao a
   * informacao vai neste campo — que ja e o usado pela forma 'conta'.
   */
  private descreverTransacao(
    forma: 'cartao' | 'qrcode',
    dados: DadosPagamentoCartao | DadosPagamentoQrCode,
  ): string {
    if (forma === 'cartao') {
      const cartao = dados as DadosPagamentoCartao;
      const partes = [this.translate.instant('forma_pagamento.cartao')];
      const informado = cartao.informacaoDaTransacao?.trim();
      if (informado) partes.push(informado);
      return partes.join(' - ');
    }

    const qrcode = dados as DadosPagamentoQrCode;
    const partes = [this.translate.instant('forma_pagamento.qrcode')];
    if (qrcode.intencaoDeRecebimentoId) partes.push(`#${qrcode.intencaoDeRecebimentoId}`);
    else if (qrcode.codigoTransacao) partes.push(qrcode.codigoTransacao);
    return partes.join(' - ');
  }

  /**
   * Zera a cobranca por QR e a cancela na Bancard.
   *
   * Chamada ao fechar o dialogo, ao trocar de forma de pagamento e ao sair da tela. Limpar so a
   * tela nao basta: o QR ja lido pelo cliente continua pagavel, e um pagamento que chegasse
   * depois seria confirmado sem venda nenhuma esperando por ele.
   *
   * Pagamento ja confirmado nao se cancela: e dele que a venda nasce.
   */
  limparEstadoQrCode(): void {
    const intencaoId = this.estadoQrCode?.intencaoId;
    const jaConfirmado = this.estadoQrCode?.confirmado === true;

    this.pararPollingQrCode();
    this.estadoQrCode = { gerando: false, confirmado: false };

    if (intencaoId == null || jaConfirmado) return;

    // Sem alerta na tela: o operador ja seguiu adiante e nao ha nada que ele possa fazer aqui.
    // Quem recusa o pagamento e o backend, pelo status da cobranca.
    this.intencaoDeRecebimentoService.cancelar(intencaoId).subscribe({ error: () => {} });
  }

  ngOnDestroy(): void {
    // Sair da tela abandona a cobranca: para o polling e cancela o QR que ficou em aberto.
    this.limparEstadoQrCode();
  }

  carregarGrupos(): void {
    const labelTodas = this.translate.instant('vendas.labels.todas_categorias');
    this.grupoService.get('/grupo/filtrarGrupo', { status: true }).subscribe({
      next: (res) => {
        this.grupos = [{ id: null, nome: labelTodas }, ...res.content];
        // Manter nome do item "Todas" sincronizado com o idioma atual
        if (!this.categoriaSelecionada.id) {
          this.categoriaSelecionada = { ...this.categoriaSelecionada, nome: labelTodas };
        }
      },
      error: () => {
        // Fallback: exibe ao menos o item "Todas Categorias" para o filtro funcionar
        this.grupos = [{ id: null, nome: labelTodas }];
        if (!this.categoriaSelecionada.id) {
          this.categoriaSelecionada = { ...this.categoriaSelecionada, nome: labelTodas };
        }
      }
    });
  }

  carregarProdutos(page: number = 0): void {
    this.loading = true;
    this.produtoNaoEncontrado = false;
    this.produtosService.getItens(page, this.tamanhoPagina).subscribe((res) => {
      this.produtosBrutos = res.content;
      this.sortProdutosByCodigoAsc();
      this.totalPaginas = res.totalPages;
      this.totalElements = res.totalElements ?? (res.totalPages * this.tamanhoPagina);
      this.aplicarFiltroSemSaldo();
      this.loading = false;

      // Revalidar saldos do cache somente na primeira carga de produtos
      if (!this.cacheRevalidado) {
        this.cacheRevalidado = true;
        this.revalidarSaldosDoCache();
      }
    });
  }

  onPaginatorChange(event: any): void {
    const page = event.page ?? 0;
    const rows = event.rows ?? this.tamanhoPagina;
    this.paginaAtual = page;
    this.tamanhoPagina = rows;
    this._ultimoTamanhoPagina = rows;
    if (this.categoriaSelecionada?.id) {
      this.carregarPorGrupo(page);
    } else {
      this.carregarProdutos(page);
    }
  }

  /**
   * Troca do "Itens por pagina" (dropdown rotulado ao lado do paginator, igual
   * as demais telas). Volta para a primeira pagina: manter o indice antigo com
   * uma pagina maior pode cair fora do total e devolver lista vazia.
   * A guarda evita recarregar quando o valor nao mudou de fato.
   */
  onRowsPerPageChange(): void {
    if (this.tamanhoPagina === this._ultimoTamanhoPagina) return;
    this._ultimoTamanhoPagina = this.tamanhoPagina;
    this.paginaAtual = 0;
    if (this.categoriaSelecionada?.id) {
      this.carregarPorGrupo(0);
    } else {
      this.carregarProdutos(0);
    }
  }

  carregarPorGrupo(page: number = 0): void {
    this.loading = true;
    this.produtoNaoEncontrado = false;

    if (this.categoriaSelecionada.id) {
      this.produtosService
        .getItensPorGrupo(this.categoriaSelecionada.id, page, this.tamanhoPagina)
        .subscribe({
          next: (res) => {
            this.produtosBrutos = res.content;
            this.sortProdutosByCodigoAsc();
            this.totalPaginas = res.totalPages;
            this.totalElements = res.totalElements ?? (res.totalPages * this.tamanhoPagina);
            this.aplicarFiltroSemSaldo();

            // Quando a categoria não possui nenhum item, exibir mensagem de vazio
            if (this.produtos.length === 0) {
              this.produtoNaoEncontrado = true;
            }

            this.loading = false;
          },
          error: () => {
            this.produtosBrutos = [];
            this.produtos = [];
            this.produtoNaoEncontrado = true;
            this.loading = false;
          },
        });
    } else {
      this.carregarProdutos();
    }
  }

  onImageError(event: Event): void {
    const img = event.target as HTMLImageElement;
    img.style.display = 'none';
    // Rastrear imagem com erro pelo id do produto para evitar colisão entre produtos com mesmo nome
    const produtoId = img.dataset['productId'];
    if (produtoId) {
      this.imagensComErro.add(produtoId);
    }
  }

  temErroImagem(produto: any): boolean {
    return this.imagensComErro.has(String(produto.id));
  }

  selecionarCategoria(grupo: any): void {
    this.categoriaSelecionada = grupo;
    this.carregarPorGrupo();
  }

      // Troco: parsing/formatting com símbolo da moeda, independente do valor recebido
  onTrocoInput(moeda: 'PYG' | 'USD' | 'BRL', ev: Event) {
    const input = ev.target as HTMLInputElement;
    const raw = input.value || '';
    const onlyDigits = raw.replace(/\D+/g, '');

    if (moeda === 'PYG') {
      const intVal = onlyDigits ? parseInt(onlyDigits, 10) : 0;
      this.trocoGuarani = intVal;
      this.trocoGuaraniStr = intVal
        ? intVal.toLocaleString('es-PY', { style: 'currency', currency: 'PYG', minimumFractionDigits: 0, maximumFractionDigits: 0 })
        : '';
      input.value = this.trocoGuaraniStr;
    } else {
      const cents = onlyDigits ? parseInt(onlyDigits, 10) : 0;
      const val = cents / 100;
      if (moeda === 'USD') {
        this.trocoDolar = val;
        this.trocoDolarStr = cents
          ? val.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 })
          : '';
        input.value = this.trocoDolarStr;
      } else {
        this.trocoReal = val;
        this.trocoRealStr = cents
          ? val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 })
          : '';
        input.value = this.trocoRealStr;
      }
    }
  }

  // Quanto troco ainda falta alocar nesta moeda (sugestão)
  trocoFaltando(moedaTexto: 'GUARANI' | 'DOLAR' | 'REAL'): number {
    const devido = this.calcularTroco(0, moedaTexto);
    const digitado =
      moedaTexto === 'GUARANI' ? (this.trocoGuarani || 0) :
      moedaTexto === 'DOLAR' ? (this.trocoDolar || 0) :
      (this.trocoReal || 0);
    const falt = devido - digitado;
    return falt > 0 ? falt : 0;
  }

  /* ------------ Carrinho ------------ */
  // O parametro `quantidadeDesejada` so e aplicado quando o produto e adicionado direto
  // (sem dialog de preco zero e sem dialog de variantes/modificadores). Em qualquer fluxo
  // que abra dialog, a multiplicacao e ignorada e o usuario define a quantidade na UI.
  /**
   * Abre o modal de detalhe do produto (carrossel + quantidade + botao).
   * Fluxo lazy: o GET das imagens secundarias so e disparado quando o componente
   * filho monta via *ngIf. Listagens nao pre-carregam imagens.
   *
   * Importante: NAO chamar este metodo pelo fluxo do leitor de codigo de barras
   * (linhas 847, 966, 1013, 1073) - o leitor adiciona direto via `adicionarProduto`.
   */
  abrirDetalheProduto(produto: any): void {
    if (!this.podeClicar(produto)) return;
    this.produtoDetalheAberto = produto;
  }

  /**
   * Handler do clique/teclado NA IMAGEM do card de produto.
   * Impede propagacao para o card pai (que chamaria adicionarProduto)
   * e delega para abrirDetalheProduto.
   */
  abrirDetalheProdutoEvento(evento: Event, produto: any): void {
    evento.stopPropagation();
    this.abrirDetalheProduto(produto);
  }

  /**
   * Handler do `(adicionarAoCarrinho)` emitido pelo `<app-vendas-produto-detalhe>`.
   * Reaproveita o fluxo existente: se tiver variantes ou preco zero, segue pelo
   * mesmo caminho de `adicionarProduto`; senao, vai direto para `adicionarProdutoComPreco`.
   */
  onAdicionarDoDetalhe(evt: { produto: any; quantidade: number }): void {
    this.produtoDetalheAberto = null;
    this.adicionarProduto(evt.produto, evt.quantidade);
  }

  adicionarProduto(produto: any, quantidadeDesejada?: number): void {
    if (!this.ehServico(produto) && this.indisponivel(produto)) {
      this.messageService.add({ severity: 'warn', summary: this.translate.instant('vendas.mensagens.indisponivel'), detail: this.translate.instant('vendas.mensagens.produto_indisponivel') });
      return;
    }

    // NOVO: se preço 0, abrir dialog para definir preço antes de adicionar
    const preco = Number(produto?.precoDeVenda ?? 0);
    if (preco <= 0) {
      this.produtoParaDefinirPreco = produto;
      this.precoVendaAtualFormatado = this.formatarValorPorMoeda(preco, this.moedaPadrao);
      // input inicia com 0 formatado
      this.valorNovoPrecoNumber = 0;
      this.precoVendaNovoStr = this.formatarValorPorMoeda(0, this.moedaPadrao);
      this.mostrarDialogPreco = true;
      setTimeout(() => this.inputNovoPreco?.nativeElement?.focus(), 0);
      return;
    }

    // Verificar se item tem variantes ou modificadores
    this.verificarVariantesEModificadores(produto, preco, quantidadeDesejada);
  }

  private adicionarProdutoComPreco(produto: any, precoDeVendaUsado: number, quantidadeDesejada?: number): void {
    const isServico = this.ehServico(produto);
    const saldoDisponivel = Number(produto?.saldo ?? 0);
    const qtdDesejada = quantidadeDesejada && quantidadeDesejada >= 1 ? Math.floor(quantidadeDesejada) : null;

    const itemExistente = this.carrinho.find((x) => x.item_id === produto.id);

    if (itemExistente) {
      if (qtdDesejada !== null) {
        // Multiplicador: define a quantidade total desejada (acumula com a ja existente).
        const totalDesejado = itemExistente.quantidade + qtdDesejada;
        const limiteMaximo = isServico ? totalDesejado : saldoDisponivel;
        const novoTotal = isServico ? totalDesejado : Math.min(totalDesejado, limiteMaximo);
        if (!isServico && novoTotal < totalDesejado) {
          this.messageService.add({
            severity: 'warn',
            summary: this.translate.instant('common.atencao'),
            detail: this.translate.instant('vendas.mensagens.quantidade_maxima_saldo'),
          });
        }
        itemExistente.quantidade = Math.max(1, novoTotal);
        this.atualizarValores(itemExistente);
        this.salvarCache();
        return;
      }

      if (isServico || itemExistente.quantidade < produto.saldo) {
        itemExistente.quantidade++;
        this.atualizarValores(itemExistente);
      } else {
        this.messageService.add({ severity: 'warn', summary: this.translate.instant('common.atencao'), detail: this.translate.instant('vendas.mensagens.quantidade_maxima_saldo') });
      }
      this.salvarCache();
      return;
    }

    // Quantidade inicial: respeita saldo para produtos (atualizarValores fara o clamp final).
    let quantidadeInicial = 1;
    if (qtdDesejada !== null) {
      quantidadeInicial = isServico ? qtdDesejada : Math.min(qtdDesejada, Math.max(1, saldoDisponivel));
      if (!isServico && quantidadeInicial < qtdDesejada) {
        this.messageService.add({
          severity: 'warn',
          summary: this.translate.instant('common.atencao'),
          detail: this.translate.instant('vendas.mensagens.quantidade_maxima_saldo'),
        });
      }
    }

    const novoItem = {
      item_id: produto.id,
      tipoDeImposto: produto.tipoDeImposto,
      quantidade: quantidadeInicial,
      valorUnitario: precoDeVendaUsado, // pode ser o novo preço
      custoUnitario: produto.custo,
      custoTotal: produto.custo,
      valorTotal: precoDeVendaUsado * quantidadeInicial,
      desconto: produto.desconto || 0,
      valorUnitarioComDesconto: 0,
      valorTotalComDesconto: precoDeVendaUsado * quantidadeInicial,
      precoDeVendaNovo: precoDeVendaUsado,
      precoDeVendaAntigo: produto.precoDeVenda,
      tipoDeDesconto: produto.tipoDeDesconto || 'SEM_DESCONTO',
      nome: produto.nome,
      imagem: produto.imagem,
      saldo: produto.saldo,
      estoqueMinimo: produto.estoqueMinimo,
      tipoItem: produto.tipoItem,
      codigoItem: produto.codigoItem ?? '',
      barras: produto.barras ?? '',
    };

    this.carrinho.unshift(novoItem);
    this.atualizarValores(novoItem);
    this.salvarCache();
  }

  atualizarValores(item: any): void {
    // Garantir quantidade mínima de 1
    item.quantidade = Math.max(1, item.quantidade || 1);

    // Garantir que não excede o saldo disponível para produtos (não serviços)
    const isServico = this.ehServico(item) || this.ehServico({ tipoItem: item?.tipoItem });
    if (!isServico && item.origemPedido && item.saldoMaximoDoPedido != null) {
      // Itens de pedido: limitar ao saldo disponivel do pedido
      const saldoMax = Number(item.saldoMaximoDoPedido);
      if (item.quantidade > saldoMax) {
        item.quantidade = saldoMax > 0 ? saldoMax : 1;
      }
    } else if (!isServico && !item.origemPedido && item.saldo != null) {
      const saldoMax = Number(item.saldo);
      if (item.quantidade > saldoMax) {
        item.quantidade = saldoMax > 0 ? saldoMax : 1;
      }
    }

    item.valorTotalComDesconto = item.valorUnitario * item.quantidade;

    // Atualizar precoTotal dos modificadores/variantes quando quantidade muda
    if (item.variantesDePreco?.length) {
      item.variantesDePreco.forEach((v: VarianteDePrecoDeItemPedidoDTO) => {
        v.quantidade = item.quantidade;
        v.precoTotal = (v.precoDeVenda || 0) * item.quantidade;
      });
    }
    if (item.modificadores?.length) {
      item.modificadores.forEach((m: ModificadorDePrecoDeItemPedidoDTO) => {
        // Preservar quantidade base do modificador (quantidade de adicionais selecionados)
        const qtdBaseModificador = m._quantidadeBase ?? m.quantidade ?? 1;
        m._quantidadeBase = qtdBaseModificador;
        m.quantidade = qtdBaseModificador * item.quantidade;
        m.precoTotal = (m.precoDeVenda || 0) * m.quantidade;
      });
    }

    this.calcularSubtotal();
    this.salvarCache();
  }

  calcularSubtotal(): number {
    this.subtotal = this.carrinho.reduce((acc, it) => acc + (it.valorTotalComDesconto || 0), 0);
    return this.subtotal;
  }

  /** Indica se a linha do carrinho tem observacao digitada pelo operador. */
  temObservacaoManual(item: any): boolean {
    return !!item?.observacaoManual?.trim();
  }

  /**
   * Observacao do item enviada ao backend: junta a observacao digitada com a que ja veio
   * no item (ex.: pedido importado), no formato "<manual> | <origem>" — mesmo padrao do Criar Pedido.
   */
  private observacaoCompletaItem(item: any): string {
    const manual = (item?.observacaoManual || '').trim();
    const origem = (item?.observacao || '').trim();
    if (!manual) return origem;
    // 'Observação' e so o placeholder exigido pela nota: nao concatenar
    if (!origem || origem === 'Observação') return manual;
    return `${manual} | ${origem}`;
  }

  /** Abre o dialog de observacao da linha (pre-preenchido com a observacao atual). */
  abrirObservacaoItem(item: any): void {
    this.itemObservacaoEmEdicao = item;
    this.observacaoItemEmEdicao = item?.observacaoManual || '';
    this.mostrarDialogObservacaoItem = true;
  }

  /** Salva a observacao digitada na linha em edicao e persiste o carrinho. */
  salvarObservacaoItem(): void {
    if (this.itemObservacaoEmEdicao) {
      this.itemObservacaoEmEdicao.observacaoManual = this.observacaoItemEmEdicao.trim();
      this.salvarCache();
    }
    this.mostrarDialogObservacaoItem = false;
  }

  /** Limpa o estado de edicao ao fechar o dialog. */
  fecharObservacaoItem(): void {
    this.itemObservacaoEmEdicao = null;
    this.observacaoItemEmEdicao = '';
  }

  incrementarQuantidade(item: any): void {
    const isServico = this.ehServico(item) || this.ehServico({ tipoItem: item?.tipoItem });

    if (isServico) {
      item.quantidade++;
      this.atualizarValores(item);
      return;
    }

    // Itens de pedido: limitar ao saldo disponivel do pedido
    if (item.origemPedido && item.saldoMaximoDoPedido != null) {
      const saldoMax = Number(item.saldoMaximoDoPedido);
      if (item.quantidade < saldoMax) {
        item.quantidade++;
        this.atualizarValores(item);
      } else {
        this.messageService.add({ severity: 'warn', summary: this.translate.instant('common.atencao'), detail: this.translate.instant('vendas.mensagens.quantidade_maxima_atingida') });
      }
      return;
    }

    const saldo = Number(item.saldo ?? 0);
    if (item.quantidade < saldo) {
      item.quantidade++;
      this.atualizarValores(item);
    } else {
      this.messageService.add({ severity: 'warn', summary: this.translate.instant('common.atencao'), detail: this.translate.instant('vendas.mensagens.quantidade_maxima_atingida') });
    }
  }

  decrementarQuantidade(item: any): void {
    if (item.quantidade > 1) {
      item.quantidade--;
      this.atualizarValores(item);
    } else {
      this.messageService.add({ severity: 'warn', summary: this.translate.instant('common.atencao'), detail: this.translate.instant('vendas.mensagens.quantidade_minima') });
    }
  }

  removerItem(item: any): void {
    // Itens com variante/modificador usam referencia direta (cada combinacao eh unica)
    if (item.variantesDePreco?.length || item.modificadores?.length) {
      const idx = this.carrinho.indexOf(item);
      if (idx >= 0) {
        this.carrinho.splice(idx, 1);
      }
    } else {
      const id = item.item_id ?? item.id;
      this.carrinho = this.carrinho.filter((p) => (p.item_id ?? p.id) !== id);
    }
    this.calcularSubtotal();
    this.salvarCache();
  }

  /* ------------ Confirmação de remoção ------------ */
  confirmarRemocaoItem(item: any): void {
    this.itemParaRemover = item;
    this.mostrarDialogRemoverItem = true;
  }

  cancelarRemocaoItem(): void {
    this.mostrarDialogRemoverItem = false;
    this.itemParaRemover = null;
  }

  confirmarRemocaoItemFinal(): void {
    if (this.itemParaRemover) {
      this.removerItem(this.itemParaRemover);
      const summary = this.translate.instant('vendas.toast.removido_summary');
      const detail  = this.translate.instant('vendas.toast.removido_detail', {
        produto: this.itemParaRemover?.nome ?? '',
        producto: this.itemParaRemover?.nome ?? ''
      });
      this.messageService.add({ severity: 'success', summary, detail });
    }
    this.mostrarDialogRemoverItem = false;
    this.itemParaRemover = null;
  }

  /* ------------ Busca ------------ */

  /**
   * Retorna o Observable correto para o termo informado, sem subscribir.
   * Usado pelo pipeline reativo de busca incremental (switchMap) para
   * garantir que apenas a ultima requisicao atualize o estado do grid.
   *
   * Retorna um objeto com { tipo, content } para que o subscriber
   * saiba qual branch de logica aplicar ao receber a resposta.
   */
  private buildBuscaObservable(termo: string): Observable<{ tipo: 'busca' | 'listagem'; content: any }> {
    if (termo) {
      return this.produtosService.buscarPorNomeOuBarras(termo).pipe(
        map((res) => ({ tipo: 'busca' as const, content: res })),
      );
    }

    // Termo vazio: retornar listagem padrao (com ou sem categoria)
    this.paginaAtual = 0;
    if (this.categoriaSelecionada?.id) {
      return this.produtosService
        .getItensPorGrupo(this.categoriaSelecionada.id, this.paginaAtual, this.tamanhoPagina)
        .pipe(map((res) => ({ tipo: 'listagem' as const, content: res })));
    }
    return this.produtosService
      .getItens(this.paginaAtual, this.tamanhoPagina)
      .pipe(map((res) => ({ tipo: 'listagem' as const, content: res })));
  }

  /**
   * Wrapper de buildBuscaObservable que adiciona catchError para manter o
   * stream externo (termoBusca$) vivo apos erros HTTP. Erros sao convertidos
   * em uma emissao de "busca vazia", fazendo o next handler exibir
   * "Produto nao encontrado" sem encerrar o pipeline reativo.
   */
  private buildBuscaComFallback(termo: string): Observable<{ tipo: 'busca' | 'listagem'; content: any }> {
    return this.buildBuscaObservable(termo).pipe(
      catchError(() => of({ tipo: 'busca' as const, content: { content: [], totalElements: 0 } })),
    );
  }

  buscarProdutos(termo: string): void {
    this.loading = true;
    this.produtoNaoEncontrado = false;

    if (termo) {
      this.produtosService.buscarPorNomeOuBarras(termo).subscribe({
        next: (res) => {
          let lista = Array.isArray(res?.content) ? res.content : [];
          // Filtrar por categoria ativa, se houver (grupo é objeto aninhado no DTO, usar matchGrupo)
          if (this.categoriaSelecionada?.id && lista.length) {
            lista = lista.filter((p: any) => this.matchGrupo(p));
          }
          if (!lista.length) {
            this.produtosBrutos = []; this.produtos = []; this.produtoNaoEncontrado = true;
          } else {
            this.produtosBrutos = lista; this.aplicarFiltroSemSaldo();
          }
          this.loading = false;
        },
        error: () => {
          this.produtosBrutos = []; this.produtos = []; this.produtoNaoEncontrado = true; this.loading = false;
        },
      });
    } else {
      this.paginaAtual = 0;
      if (this.categoriaSelecionada?.id) {
        this.carregarPorGrupo();
      } else {
        this.carregarProdutos();
      }
    }
  }

  /* ------------ Clientes ------------ */
  carregarClientes(): void {
    // Apenas aplica o cliente padrao (se configurado)
    this.aplicarClientePadrao();
  }

  onClienteSelecionado(cliente: any): void {
    this.pessoa_id = cliente?.id ?? null;
    this.salvarCache();
  }

  /* ------------ Importar pedido ------------ */

  /**
   * Libera o botao de importar pedido.
   *
   * Usa a mesma permissao que guarda a tela de Pedidos: sem ela o operador veria uma lista de
   * pedidos que nao pode abrir.
   */
  get podeImportarPedido(): boolean {
    return this.permissaoService.temPermissao('gestaoDePedidos');
  }

  abrirImportarPedido(): void {
    this.mostrarDialogImportarPedido = true;
  }

  /**
   * O dialog ja gravou o carrinho e o vinculo com o pedido no cache do PDV; aqui so recarregamos o
   * estado da tela a partir dele — o mesmo caminho de quem chega pelo botao "Faturar" da tela de
   * Pedidos, que grava o cache e navega para ca.
   */
  onPedidoImportado(): void {
    this.mostrarDialogImportarPedido = false;
    // `restaurarCache` repovoa carrinho, observacao e o vinculo com o pedido a partir do cache.
    this.restaurarCache();
  }

  /* ------------ Cancelar ------------ */
  abrirConfirmacaoCancelarPedido(): void {
    this.mostrarDialogLimparCarrinho = true;
  }

  onDialogLimparCarrinhoShow(): void {
    setTimeout(() => {
      this.btnConfirmarLimparCarrinho?.nativeElement?.focus();
    }, 0);
  }

  fecharDialogLimparCarrinho(): void {
    this.mostrarDialogLimparCarrinho = false;
  }

  confirmarLimparCarrinho(): void {
    this.cancelarPedido();
    this.mostrarDialogLimparCarrinho = false;
  }

  cancelarPedido(): void {
    this.carrinho = [];
    this.itemDeNota = [];
    this.observacao = '';
    this.pedidoIdDoCache = null;
    this.descontos = 0;
    this.tipoDeDesconto = null;
    this.valorDesconto = null;
    // Carrinho vazio: aplicar padrão empresa para cliente e timbrado
    this.clienteSelecionado = undefined;
    this.pessoa_id = null;
    this.aplicarClientePadrao();
    this.timbradoSelecionado = { value: null, id: -1 } as any;
    this.timbradoSelecionadoId = -1;
    this.aplicarTimbradoPadrao();
    this.salvarCache();
  }

  novoCliente(): void {
    this.router.navigate(['/adicionar-cliente']);
  }

  navegarParaPlanos(): void {
    this.mostrarDialogLimitePlano = false;
    this.router.navigate(['/planos']);
  }

  /* ------------ Desconto ------------ */
  abrirDialogDesconto(): void {
    this.mostrarDialogDesconto = true;
  }
  private abrirDialogDescontoHotkey(): void {
    this.mostrarDialogDesconto = true;
  }
  onDialogDescontoShow(): void {
    setTimeout(() => this.tipoDescDD?.show(), 150);
  }
  focarDropdownDesconto(): void {
    setTimeout(() => this.tipoDescDD?.focus(), 0);
  }

  aplicarDesconto(): void {
    const descontoCalculado =
      this.tipoDeDesconto?.value === 'PERCENTUAL'
        ? (this.calcularSubtotal() * (this.valorDesconto || 0)) / 100
        : this.valorDesconto || 0;

    if (descontoCalculado > this.calcularSubtotal()) {
      this.messageService.add({ severity: 'error', summary: this.translate.instant('common.erro'), detail: this.translate.instant('vendas.mensagens.desconto_ultrapassou_subtotal') });
      return;
    }

    this.descontos = descontoCalculado;
    this.mostrarDialogDesconto = false;
    this.salvarCache();
  }

  cancelarDesconto(): void { this.mostrarDialogDesconto = false; }

  onTipoDeDescontoChange(tipo: TipoDeDescontoOption): void {
    this.tipoDeDesconto = tipo;
    this.valorDesconto = null;
    this.salvarCache();

    if (this.tipoDeDesconto?.value === 'PERCENTUAL' || this.tipoDeDesconto?.value === 'VALOR') {
      setTimeout(() => this.valorDescontoInput?.input?.nativeElement?.focus(), 100);
    }
  }

  private formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hour = String(date.getHours()).padStart(2, '0');
    const minute = String(date.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year}T${hour}:${minute}`;
  }

  /* ------------ Venda ------------ */
  criarNotaFinal(): any {
    const timbrado = this.timbradoSelecionado?.value;
    const agora = new Date();

    // Calcular valores por tipo de item
    const itens = this.gerarItensDeNota();
    const valorTotalEmServicos = itens
      .filter((item: any) => item.tipoItem === 'SERVICO')
      .reduce((sum: number, item: any) => sum + (item.valorTotalComDesconto || 0), 0);

    const valorTotalEmMercadorias = itens
      .filter((item: any) => item.tipoItem !== 'SERVICO')
      .reduce((sum: number, item: any) => sum + (item.valorTotalComDesconto || 0), 0);

    // Usar moeda já carregada (via carregarPadroesDaEmpresa no ngOnInit)
    const moedaEnum = this.moedaIsoParaEnum[this.moedaPadrao] || 'GUARANI';

    if (!this.vendedorPessoaId) {
      throw new Error('Vendedor não identificado. Tente recarregar a página.');
    }

    // timbrado_id só é válido se o id existir e for > 0
    const timbradoId = timbrado?.id || null;

    return {
      emissao: toLocalISOString(agora),
      emissaoFatura: toLocalISOString(agora),
      tipoDeTransacao: 'VENDA',
      ehFaturaLegal: !!timbradoId,
      numeroFatura: timbrado?.proximoNumero || null,
      numeroPontoExpedicao: timbrado?.pontoDeExpedicao || null,
      numeroFilial: timbrado?.numeroFilial || null,
      tipoNota: timbrado ? (timbrado.tipoNota?.enum ?? timbrado.tipoNota ?? 'VENDA_COMUM') : 'VENDA_COMUM',
      condicaoDePagamento: '',
      // Preenchido em finalizarVenda conforme a forma escolhida no dialog.
      formaDePagamento: null,
      cotacao_id: 1,
      custoTotalDosItens: this.calcularSubtotal(),
      valorTotal: this.calcularSubtotal(),
      valorDoDesconto: this.descontos || 0,
      tipoDeDesconto: this.tipoDeDesconto?.value || 'SEM_DESCONTO',
      porcentagemDesconto: this.tipoDeDesconto?.value === 'PERCENTUAL' ? this.valorDesconto || 0 : 0,
      valorTotalComDesconto: this.calcularSubtotal() - (this.descontos || 0),
      valorRecebidoNaConta: 0,
      valorRecebidoEmGuarani: 0,
      valorRecebidoEmDolar: 0,
      valorRecebidoEmReal: 0,
      valorRecebidoEmPeso: 0,
      informacaoDaTransacao: '',
      moeda: moedaEnum,
      cancelado: false,
      pessoa_id: this.clienteSelecionado?.id || null,
      vendedor_id: this.vendedorPessoaId,
      timbrado_id: timbradoId,
      numeroTimbrado: this.timbradoSelecionado?.value?.timbrado || null,
      observacao: this.observacao || '',
      pedidoId: this.pedidoIdDoCache || null,
      itemDeNota: itens.map((item: any) => ({ ...item, observacao: item.observacao || 'Observação' })),
      valorTotalEmServicos: valorTotalEmServicos,
      valorTotalEmMercadorias: valorTotalEmMercadorias,
      chaveNotaEletronica: '',
      baixas: [],
      titulos: this.titulos,
      numeroParcelas: this.numeroParcelas,
    };
  }

  private gerarItensDeNota(): any[] {
    if (!this.carrinho || this.carrinho.length === 0) return [];

    const totalDesconto = this.descontos || 0;
    const dec = this.casasDecimaisDaMoeda();
    const factor = Math.pow(10, dec);

    // Pré-calcular valorTotal de cada item para distribuição proporcional
    const itensComValores = this.carrinho.map((produto) => {
      const quantidade = produto.quantidade || 0;
      const valorUnitario = produto.valorUnitario ?? produto.precoDeVenda ?? 0;
      const custoUnitario = produto.custoUnitario ?? produto.custo ?? 0;
      const valorTotal = valorUnitario * quantidade;
      const custoTotal = custoUnitario * quantidade;
      return { produto, quantidade, valorUnitario, custoUnitario, valorTotal, custoTotal };
    });

    const subtotalGeral = itensComValores.reduce((acc, it) => acc + it.valorTotal, 0);

    // Distribuir desconto proporcionalmente ao valor de cada item (em centavos para evitar arredondamento)
    const descontoEmCents = Math.round(totalDesconto * factor);
    let descontoDistribuido = 0;

    return itensComValores.map((it, index) => {
      const isUltimo = index === itensComValores.length - 1;

      let descontoItemCents: number;
      if (subtotalGeral <= 0) {
        // Sem subtotal: dividir igualmente como fallback
        descontoItemCents = isUltimo
          ? descontoEmCents - descontoDistribuido
          : Math.floor(descontoEmCents / itensComValores.length);
      } else if (isUltimo) {
        // Último item recebe o restante para garantir soma exata
        descontoItemCents = descontoEmCents - descontoDistribuido;
      } else {
        descontoItemCents = Math.floor((it.valorTotal / subtotalGeral) * descontoEmCents);
      }

      // Garantir que o desconto não ultrapasse o valor total do item
      const valorTotalItemCents = Math.round(it.valorTotal * factor);
      if (descontoItemCents > valorTotalItemCents) {
        descontoItemCents = valorTotalItemCents;
      }
      if (descontoItemCents < 0) descontoItemCents = 0;

      descontoDistribuido += descontoItemCents;

      const descontoItem = descontoItemCents / factor;
      const valorTotalComDesconto = it.valorTotal - descontoItem;
      const valorUnitarioComDesconto = it.quantidade > 0 ? valorTotalComDesconto / it.quantidade : it.valorUnitario;

      return {
        item_id: it.produto.item_id ?? it.produto.id,
        tipoDeImposto: it.produto.tipoDeImposto?.enum ?? it.produto.tipoDeImposto ?? null,
        tipoItem: it.produto.tipoItem ?? 'MERCADORIA',
        quantidade: it.quantidade,
        valorUnitario: it.valorUnitario,
        custoUnitario: it.custoUnitario,
        custoTotal: it.custoTotal,
        valorTotal: it.valorTotal,
        desconto: descontoItem,
        valorUnitarioComDesconto,
        valorTotalComDesconto,
        precoDeVendaNovo: it.produto.precoDeVendaNovo,
        precoDeVendaAntigo: it.produto.precoDeVendaAntigo,
        observacao: this.observacaoCompletaItem(it.produto) || 'Observação',
        modificadores: it.produto.modificadores || [],
        variantesDePreco: it.produto.variantesDePreco || [],
        itemDePedido_id: it.produto.itemDePedidoId || null,
      };
    });
  }

  /**
   * Monta o payload do pedido a partir dos dados do carrinho.
   * Alinhamento com o fluxo do mobile: criar pedido antes da nota.
   */
  finalizarPedido(): void {
    if (this.carrinho.length === 0) {
      this.messageService.add({ severity: 'warn', summary: this.translate.instant('common.atencao'), detail: this.translate.instant('vendas.mensagens.carrinho_vazio') });
      return;
    }
    if (!this.clienteSelecionado) {
      this.messageService.add({ severity: 'warn', summary: this.translate.instant('common.atencao'), detail: this.translate.instant('vendas.mensagens.selecione_cliente') });
      return;
    }

    // Validar dados do cliente para nota eletronica
    const timbrado = this.timbradoSelecionado?.value;
    const tipoNota = timbrado?.tipoNota?.enum ?? timbrado?.tipoNota ?? '';
    if (tipoNota && this.ehNotaEletronica(tipoNota)) {
      const camposFaltantes: string[] = [];
      if (!this.clienteSelecionado.ruc) {
        camposFaltantes.push(this.translate.instant('vendas.mensagens.campo_ruc'));
      }
      if (!this.clienteSelecionado.cidade_id && !(this.clienteSelecionado as any).cidade) {
        camposFaltantes.push(this.translate.instant('vendas.mensagens.campo_cidade'));
      }
      if (!this.clienteSelecionado.telefone) {
        camposFaltantes.push(this.translate.instant('vendas.mensagens.campo_telefone'));
      }
      if (camposFaltantes.length > 0) {
        this.camposFaltantesNfe = camposFaltantes;
        this.mostrarDialogDadosClienteNfe = true;
        return;
      }
    }

    void this.abrirPagamentoComCotacao();
  }

  /**
   * Garante a cotacao do dia (solicita ao usuario se nao houver) ANTES de abrir
   * o pagamento, para o dialogo ja exibir as taxas reais. Cancelou: nao abre.
   */
  private async abrirPagamentoComCotacao(): Promise<void> {
    const cotacao = await this.cotacaoGuard.garantirCotacao({
      moeda: this.moedaIsoParaEnum[this.moedaPadrao] || 'GUARANI',
      fallbackGuarani: true,
    });
    if (!cotacao) {
      return;
    }
    this.carregarCotacaoAtual();
    this.resetarCamposPagamento();
    this.formaPagamentoSelecionada = 'dinheiro';
    this.mostrarDialogPagamento = true;
  }

  /** Handler do evento (confirmar) do FormaPagamentoDialogComponent */
  async onPagamentoConfirmado(result: FormaPagamentoResult): Promise<void> {
    if (this.processandoVenda) return;

    // Marca se a venda é com timbrado eletrônico (fatura legal) — usado no catch
    // para fechar o dialog de pagamento em erros de validação (ex.: cliente sem telefone).
    let notaEletronica = false;

    try {
      this.processandoVenda = true;
      console.log('[Venda] Iniciando finalização...', result.forma);

      // Recarregar config de impressao da empresa (pode ter mudado sem F5)
      try {
        const configRes: any = await firstValueFrom(this.empresaConfigService.get(`/configuracaoEmpresa/${this.idEmpresa}`));
        const rawTipoImprimir = configRes?.tipoImprimir;
        this.tipoImprimir = typeof rawTipoImprimir === 'string'
          ? rawTipoImprimir
          : rawTipoImprimir?.enum ?? rawTipoImprimir?.tipoEnum ?? 'PERGUNTAR';
        const formatoImpressao = configRes?.tipoDeFormatoDaImpressao?.enum ?? configRes?.tipoDeFormatoDaImpressao;
        if (formatoImpressao === 'BOBINA_58' || formatoImpressao === 'BOBINA_80' || formatoImpressao === 'A4') {
          this.opcaoImpressaoFatura = formatoImpressao;
        }
        this.deveImprimirFicha = configRes?.deveImprimirFicha === true;
      } catch (e) { /* usa valor em memoria se falhar */ }

      const notaFinal = this.criarNotaFinal();
      console.log('[Venda] NotaFinal criada, moeda:', notaFinal.moeda);
      notaEletronica = !!notaFinal.tipoNota && this.ehNotaEletronica(notaFinal.tipoNota);

      // Cotação vigente é necessária para qualquer condição de pagamento
      // (CONTADO em dinheiro, CONTADO via conta ou CREDITO a prazo) para que
      // o backend consiga converter os valores para a moeda base (guarani).
      console.log('[Venda] Buscando cotação para moeda:', this.moedaPadrao);
      notaFinal.cotacao_id = await this.buscarCotacaoId();
      console.log('[Venda] Cotação obtida, id:', notaFinal.cotacao_id);

      if (result.forma === 'dinheiro') {
        const dados = result.dados as DadosPagamentoDinheiro;
        notaFinal.condicaoDePagamento = 'CONTADO';
        notaFinal.formaDePagamento = FormaDePagamento.CONTADO;

        // Os valores recebidos por moeda ja chegam LIQUIDOS do dialog
        // (FormaPagamentoDialogComponent.construirDados):
        //   valorRecebidoEmM = valorDigitadoEmM - trocoEmM
        //
        // Sinais possiveis em cada campo:
        //   > 0  -> entrada liquida de caixa naquela moeda
        //   = 0  -> moeda nao foi utilizada
        //   < 0  -> saida de caixa naquela moeda (cliente apenas RECEBEU troco
        //           nessa moeda, sem ter entregado valor nela). O backend trata
        //           o valor negativo como movimentacao de saida.
        //
        // Para o caso de TROCO CAMBIAL (cliente paga em moeda X e recebe troco em moeda Y),
        // a moeda X chega positiva (entrada) e a moeda Y chega negativa (saida).
        // O backend concilia a soma global pela cotacao vigente.
        notaFinal.valorRecebidoEmGuarani = dados.valorRecebidoEmGuarani || 0;
        notaFinal.valorRecebidoEmDolar   = dados.valorRecebidoEmDolar   || 0;
        notaFinal.valorRecebidoEmReal    = dados.valorRecebidoEmReal    || 0;
        notaFinal.valorRecebidoEmPeso    = dados.valorRecebidoEmPeso    || 0;

        notaFinal.valorRecebidoNaConta = 0;
        notaFinal.numeroParcelas = 0;
        notaFinal.titulos = [];
      }

      if (result.forma === 'conta') {
        const dados = result.dados as DadosPagamentoConta;
        notaFinal.condicaoDePagamento = 'CONTADO';
        notaFinal.formaDePagamento = FormaDePagamento.TRANSFERENCIA;
        // spec 11: garante cotacao_id atual da empresa para validacao backend de PESO
        notaFinal.cotacao_id = await this.buscarCotacaoId();
        // Backend grava Baixa.valor = valorRecebidoNaConta direto (sem reconverter).
        // Origem da conversao = moeda padrao da empresa (todos os valor* da nota estao
        // nessa moeda). Se a moeda da conta diferir, converte direto par-a-par
        // (cotPYG/cotBRL/cotPesoGuarani/cotRealGuarani).
        //
        // Guard de pareamento: a conversao direta proibe ARS<->USD/BRL (espelha o
        // backend). Valida ANTES do POST e aborta com toast caso a conta escolhida
        // seja incompativel com a moeda da empresa — nao usa excecao como fluxo.
        const moedaEmpresaEnum = this.moedaIsoParaEnum[this.moedaPadrao] || 'GUARANI';
        if (dados.moedaDaConta && !podeConverterEntre(moedaEmpresaEnum, dados.moedaDaConta)) {
          this.messageService.add({
            severity: 'warn',
            summary: this.translate.instant('forma_pagamento.moeda_incompativel_titulo'),
            detail: this.translate.instant('forma_pagamento.moeda_incompativel_detalhe'),
          });
          this.processandoVenda = false;
          return;
        }
        // Defesa em profundidade: ainda que o guard acima falhe, a excecao de par
        // proibido nunca deve quebrar a tela.
        try {
          notaFinal.valorRecebidoNaConta = this.calcularValorRecebidoNaConta(
            notaFinal.valorTotalComDesconto,
            dados.moedaDaConta,
          );
        } catch (erroConversao) {
          if (erroConversao instanceof ConversaoNaoPermitidaError) {
            this.messageService.add({
              severity: 'warn',
              summary: this.translate.instant('forma_pagamento.moeda_incompativel_titulo'),
              detail: this.translate.instant('forma_pagamento.moeda_incompativel_detalhe'),
            });
            this.processandoVenda = false;
            return;
          }
          throw erroConversao;
        }
        notaFinal.conta_id = dados.conta_id;
        notaFinal.moedaDaConta = dados.moedaDaConta;
        notaFinal.informacaoDaTransacao = dados.informacaoDaTransacao;

        notaFinal.valorRecebidoEmGuarani = 0;
        notaFinal.valorRecebidoEmDolar = 0;
        notaFinal.valorRecebidoEmReal = 0;
        notaFinal.valorRecebidoEmPeso = 0;
        notaFinal.numeroParcelas = 0;
        notaFinal.titulos = [];
      }

      // Tarjeta e QR Code entram no caixa como recebimento em CONTA: o dinheiro cai
      // numa conta cadastrada, exatamente como a forma 'conta'. O que muda e a
      // rastreabilidade, registrada em informacaoDaTransacao.
      if (result.forma === 'cartao' || result.forma === 'qrcode') {
        const dados = result.dados as DadosPagamentoCartao | DadosPagamentoQrCode;
        notaFinal.condicaoDePagamento = 'CONTADO';
        // Tarjeta e QR caem na mesma conta; so este campo os separa depois.
        notaFinal.formaDePagamento = result.forma === 'cartao'
          ? FormaDePagamento.TARJETA
          : FormaDePagamento.QR_CODE;
        notaFinal.cotacao_id = await this.buscarCotacaoId();

        // Mesmo guard de pareamento de moeda da forma 'conta': evita 422 pos-submit.
        const moedaEmpresaEnum = this.moedaIsoParaEnum[this.moedaPadrao] || 'GUARANI';
        if (dados.moedaDaConta && !podeConverterEntre(moedaEmpresaEnum, dados.moedaDaConta)) {
          this.messageService.add({
            severity: 'warn',
            summary: this.translate.instant('forma_pagamento.moeda_incompativel_titulo'),
            detail: this.translate.instant('forma_pagamento.moeda_incompativel_detalhe'),
          });
          this.processandoVenda = false;
          return;
        }
        try {
          notaFinal.valorRecebidoNaConta = this.calcularValorRecebidoNaConta(
            notaFinal.valorTotalComDesconto,
            dados.moedaDaConta,
          );
        } catch (erroConversao) {
          if (erroConversao instanceof ConversaoNaoPermitidaError) {
            this.messageService.add({
              severity: 'warn',
              summary: this.translate.instant('forma_pagamento.moeda_incompativel_titulo'),
              detail: this.translate.instant('forma_pagamento.moeda_incompativel_detalhe'),
            });
            this.processandoVenda = false;
            return;
          }
          throw erroConversao;
        }
        notaFinal.conta_id = dados.conta_id;
        notaFinal.moedaDaConta = dados.moedaDaConta;
        notaFinal.informacaoDaTransacao = this.descreverTransacao(result.forma, dados);

        notaFinal.valorRecebidoEmGuarani = 0;
        notaFinal.valorRecebidoEmDolar = 0;
        notaFinal.valorRecebidoEmReal = 0;
        notaFinal.valorRecebidoEmPeso = 0;
        notaFinal.numeroParcelas = 0;
        notaFinal.titulos = [];
      }

      if (result.forma === 'prazo') {
        const dados = result.dados as DadosPagamentoPrazo;
        notaFinal.condicaoDePagamento = 'CREDITO';
        notaFinal.formaDePagamento = FormaDePagamento.CREDITO;
        // spec 11: garante cotacao_id atual da empresa para validacao backend de PESO
        notaFinal.cotacao_id = await this.buscarCotacaoId();
        notaFinal.numeroParcelas = dados.numeroParcelas;
        notaFinal.titulos = dados.titulos;

        notaFinal.valorRecebidoEmGuarani = 0;
        notaFinal.valorRecebidoEmDolar = 0;
        notaFinal.valorRecebidoEmReal = 0;
        notaFinal.valorRecebidoEmPeso = 0;
        notaFinal.valorRecebidoNaConta = 0;
      }

      // Verificar limite do plano antes de criar a nota.
      // O endpoint retorna 422 exclusivamente quando o limite do plano é atingido.
      // Outros erros (rede, 5xx): política C — não bloquear a venda por falha de infraestrutura.
      try {
        await firstValueFrom(this.planosService.verificarLimiteVendas(notaFinal.valorTotalComDesconto));
      } catch (erroLimite: any) {
        if (erroLimite?.status === 422) {
          this.mostrarDialogLimitePlano = true;
          this.processandoVenda = false;
          return;
        }
        // Outros erros de rede/backend: prosseguir com a venda (política C)
        console.warn('[Venda] Falha ao verificar limite do plano, prosseguindo:', erroLimite?.status);
      }

      console.log('[Venda] Enviando nota ao backend...');
      const respostaNota = await firstValueFrom(this.notaService.postParaVenda('/nota', notaFinal));
      console.log('[Venda] Resposta recebida, id:', respostaNota?.id);

      this.notaGerada = respostaNota;
      this.idNotaGerada = respostaNota?.id || null;

      this.mostrarDialogPagamento = false;
      // Capturar antes de cancelarPedido() zerar pedidoIdDoCache
      this.veioDePedido = !!this.pedidoIdDoCache;
      this.pedidoIdParaReabrir = this.pedidoIdDoCache;
      this.cancelarPedido();
      if (this.categoriaSelecionada?.id) {
        this.carregarPorGrupo(this.paginaAtual);
      } else {
        this.carregarProdutos(this.paginaAtual);
      }
      // Resetar timbrado para o valor inicial, forçando aplicarTimbradoPadrao() a usar o padrão da empresa
      this.timbradoSelecionado = { value: null, id: -1 };
      this.timbradoSelecionadoId = -1;
      this.carregarTimbrados();

      if (this.idNotaGerada) {
        // Usar tipoNota do notaFinal (já sabemos o tipo que foi enviado)
        const tipoNota = notaFinal.tipoNota;

        if (tipoNota && this.ehNotaEletronica(tipoNota)) {
          // Nota eletronica: transmitir automaticamente
          this.transmitirNfeAutomatica(this.idNotaGerada);
        } else {
          // Nota manual: fluxo existente
          this.carregarNotaCompleta(this.idNotaGerada);
        }
      }
    } catch (error: any) {
      console.error('[Venda] Erro ao finalizar:', error);
      let mensagem = this.translate.instant('vendas.messages.erro_finalizar_venda');

      if (error?.message === 'cotacao_cancelada') {
        // Sem cotacao a venda nao e finalizada; aviso ja exibido pelo guard.
        return;
      }
      if (error?.message === 'cotacao_nao_encontrada') {
        mensagem = this.translate.instant('vendas.messages.cotacao_nao_encontrada');
        this.messageService.add({ severity: 'error', summary: this.translate.instant('erro'), detail: mensagem });
      }
      // Demais erros HTTP sao exibidos pelo HttpErrorInterceptor global.

      // Venda com timbrado eletronico (fatura legal): erros de validacao (4xx),
      // como cliente sem telefone, exigem corrigir os dados fora do dialog de
      // pagamento. Fecha o popup para o usuario ver o erro e ajustar o cliente.
      const status = error?.status;
      if (notaEletronica && typeof status === 'number' && status >= 400 && status < 500) {
        this.mostrarDialogPagamento = false;
      }
    } finally {
      this.processandoVenda = false;
    }
  }

  /**
   * BLOCO 8 - Tarefa 8.1: Resetar campos ao trocar forma de pagamento
   * Zera todos os campos de pagamento (dinheiro, conta, prazo) para evitar
   * valores residuais ao trocar entre formas de pagamento.
   */
  private resetarCamposPagamento(): void {
    // Campos de dinheiro - valores numéricos
    this.valorRecebidoEmGuarani = 0;
    this.valorRecebidoEmDolar = 0;
    this.valorRecebidoEmReal = 0;

    // Campos de dinheiro - strings formatadas
    this.valorGuaraniStr = '';
    this.valorDolarStr = '';
    this.valorRealStr = '';

    // Campos de troco - valores numéricos
    this.trocoGuarani = 0;
    this.trocoDolar = 0;
    this.trocoReal = 0;

    // Campos de troco - strings formatadas
    this.trocoGuaraniStr = '';
    this.trocoDolarStr = '';
    this.trocoRealStr = '';

    // Totais de dinheiro
    this.totalPago = 0;
    this.totalTroco = 0;
    this.totalEnviado = 0;

    // Campos de conta
    this.contaSelecionada = null;
    this.informacaoDaTransacao = '';

    // Campos de prazo
    this.numeroParcelas = 1;
    this.titulos = [];
  }

  /**
   * Chamado pelo (ngModelChange) do p-radioButton quando o usuário
   * troca entre Efectivo/Cuenta/Credito.
   * Reseta campos (BLOCO 8), configura forma, prefill e foco.
   */
  onFormaPagamentoChange(forma: 'dinheiro' | 'conta' | 'prazo'): void {
    this.resetarCamposPagamento();
    this.formaPagamentoSelecionada = forma;

    if (forma === 'dinheiro') {
      this.selectedMoneyCode = (this.moedaPadrao as any) || 'BRL';
      this.prefillMoneyDefault();
    }

    setTimeout(() => this.focusPrimeiroCampoDaForma(), 0);
  }

  private focusPrimeiroCampoDaForma(): void {
    if (this.formaPagamentoSelecionada === 'dinheiro') {
      setTimeout(() => this.inputGuarani?.nativeElement?.focus(), 0);
    } else if (this.formaPagamentoSelecionada === 'conta') {
      setTimeout(() => { this.contaDD?.show(); this.contaDD?.focus(); }, 0);
    } else if (this.formaPagamentoSelecionada === 'prazo') {
      setTimeout(() => this.numeroParcelasInput?.nativeElement?.focus(), 0);
    }
  }

  fecharDialogPagamento(): void {
    this.mostrarDialogPagamento = false;
    this.formaPagamentoSelecionada = 'dinheiro';
    this.limparEstadoQrCode();
  }

  casasDecimaisDaMoeda(): number {
    return this.moedaPadrao === 'PYG' ? 0 : 2;
  }

  validarValorDesconto(): void { if ((this.valorDesconto ?? 0) < 0) this.valorDesconto = 0; }

  /**
   * BLOCO 6 - Tarefa 6.4: Calcula o total recebido em dinheiro, convertido para a moeda base.
   * Usado para validar se o valor recebido é suficiente para cobrir o total da venda.
   */
  calcularTotalRecebidoEmMoedaBase(): number {
    // Converte todos os valores recebidos para USD e depois para a moeda padrão
    const recebidoEmUSD = this.toUSD(this.valorRecebidoEmGuarani || 0, 'PYG')
                        + this.toUSD(this.valorRecebidoEmDolar || 0, 'USD')
                        + this.toUSD(this.valorRecebidoEmReal || 0, 'BRL');
    return this.fromUSD(recebidoEmUSD, this.moedaPadrao);
  }

  formatarDataAtual(): string {
    const hoje = new Date();
    const dia = String(hoje.getDate()).padStart(2, '0');
    const mes = String(hoje.getMonth() + 1).padStart(2, '0');
    const ano = hoje.getFullYear();
    return `${dia}/${mes}/${ano}`;
  }

  /**
   * Calcula o valor a ser enviado em `valorRecebidoNaConta` para pagamento via conta.
   *
   * Regra (alinhada com backend que grava Baixa.valor direto sem reconverter):
   * - Os valores monetarios da nota (valorTotal, valorTotalComDesconto, etc.) estao
   *   SEMPRE na moeda padrao da empresa (this.moedaPadrao), nao na moeda da nota.
   * - Se a moeda da conta == moeda padrao da empresa, envia o valor tal qual.
   * - Se diferem, converte da moeda padrao da empresa para a moeda da conta usando
   *   a cotacao ja carregada em memoria (this.cotPYG, this.cotBRL, this.cotPesoGuarani,
   *   this.cotRealGuarani).
   *
   * Espelha a logica do dialog (toUSD/fromUSD) via util compartilhado.
   */
  private calcularValorRecebidoNaConta(
    valorTotal: number,
    moedaConta: string | undefined,
  ): number {
    const moedaEmpresa = this.moedaIsoParaEnum[this.moedaPadrao] || 'GUARANI';
    if (!moedaConta || moedaConta === moedaEmpresa) {
      return valorTotal;
    }
    const origemIso = enumMoedaParaIso(moedaEmpresa);
    const destinoIso = enumMoedaParaIso(moedaConta);
    if (!origemIso || !destinoIso) {
      return valorTotal; // fallback defensivo — moeda desconhecida
    }
    // Conversao DIRETA par-a-par (espelha ConversorMoedasUtil.kt do backend).
    return converterDireto(valorTotal, origemIso, destinoIso, {
      cotPYG: this.cotPYG,
      cotBRL: this.cotBRL,
      cotRealGuarani: this.cotRealGuarani,
      cotPesoGuarani: this.cotPesoGuarani,
    });
  }

  async buscarCotacaoId(): Promise<number> {
    // Rede de seguranca: solicita a cotacao se sumiu entre abrir o pagamento e
    // confirmar. Mantem o fallback GUARANI historico do PDV.
    const cotacao = await this.cotacaoGuard.garantirCotacao({
      moeda: this.moedaIsoParaEnum[this.moedaPadrao] || 'GUARANI',
      fallbackGuarani: true,
    });
    if (cotacao?.id) return cotacao.id;
    // Usuario cancelou o dialogo: o guard ja avisou; apenas aborta a venda.
    throw new Error('cotacao_cancelada');
  }

  /* ------------ DINHEIRO ------------ */

  /** seta a linha selecionada visualmente ao focar um input */
  setSelectedMoney(code: 'PYG'|'USD'|'BRL') {
    this.selectedMoneyCode = code;
  }

  // ------ Conversões baseadas em USD ------
  private toUSD(valor: number, from: 'USD'|'PYG'|'BRL'|'ARS'): number {
    if (from === 'USD') return valor;
    if (from === 'PYG') return valor / this.cotPYG;
    if (from === 'BRL') {
      // Caminho direto BRL -> PYG -> USD (evita erro de triangulacao)
      if (this.cotRealGuarani && this.cotPYG) {
        return (valor * this.cotRealGuarani) / this.cotPYG;
      }
      // Fallback: triangulacao via USD (empresa sem cotacao direta)
      return valor / this.cotBRL;
    }
    // ARS -> PYG -> USD (cotPesoGuarani e quantos PYG cada ARS vale)
    if (!this.cotPesoGuarani || this.cotPYG === 0) return 0;
    return (valor * this.cotPesoGuarani) / this.cotPYG;
  }
  private fromUSD(usd: number, to: 'USD'|'PYG'|'BRL'|'ARS'): number {
    if (to === 'USD') return usd;
    if (to === 'PYG') return usd * this.cotPYG;
    if (to === 'BRL') {
      // Caminho direto PYG -> BRL via cotacao direta
      if (this.cotRealGuarani && this.cotPYG) {
        return (usd * this.cotPYG) / this.cotRealGuarani;
      }
      // Fallback: triangulacao via USD
      return usd * this.cotBRL;
    }
    // USD -> PYG -> ARS
    if (!this.cotPesoGuarani) return 0;
    return (usd * this.cotPYG) / this.cotPesoGuarani;
  }

  private totalAPagarEm(m: 'USD'|'PYG'|'BRL'|'ARS'): number {
    const total = this.calcularSubtotal() - (this.descontos || 0);
    // total está em this.moedaPadrao -> converter para USD e depois para "m"
    const totalUSD = this.toUSD(total, this.moedaPadrao as any);
    return this.fromUSD(totalUSD, m);
  }

  private totalPagoEm(m: 'USD'|'PYG'|'BRL'|'ARS'): number {
    const usd = this.toUSD(this.valorRecebidoEmDolar, 'USD')
              + this.toUSD(this.valorRecebidoEmGuarani, 'PYG')
              + this.toUSD(this.valorRecebidoEmReal, 'BRL');
    return this.fromUSD(usd, m);
  }

  private totalAPagarUSD(): number {
    const total = this.calcularSubtotal() - (this.descontos || 0);
    return this.toUSD(total, this.moedaPadrao as any);
  }

  private pagoUSD(): number {
    return this.toUSD(this.valorRecebidoEmDolar, 'USD') +
           this.toUSD(this.valorRecebidoEmGuarani, 'PYG') +
           this.toUSD(this.valorRecebidoEmReal, 'BRL');
  }

  private remainingUSD(): number {
    const r = this.totalAPagarUSD() - this.pagoUSD();
    return r > 0 ? r : 0;
  }

  remainingEm(moeda: 'USD'|'PYG'|'BRL'|'ARS'): string {
    const remUSD = this.remainingUSD();
    if (moeda === 'USD') {
      return (remUSD * this.cotUSD).toLocaleString('en-US', { style:'currency', currency:'USD', minimumFractionDigits: 2 });
    } else if (moeda === 'PYG') {
      const val = remUSD * this.cotPYG;
      return val.toLocaleString('es-PY', { style:'currency', currency:'PYG', minimumFractionDigits: 0, maximumFractionDigits: 0 });
    } else if (moeda === 'ARS') {
      // ARS delega ao CLDR `es-AR` que produz `$ N,NN`
      // (decisao tech lead 2026-05-06).
      const val = this.fromUSD(remUSD, 'ARS');
      return this.formatarPesoArgentino(val);
    } else {
      return this.fromUSD(remUSD, 'BRL').toLocaleString('pt-BR', { style:'currency', currency:'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
  }

  onMoneyInput(moeda: 'PYG' | 'USD' | 'BRL', ev: Event) {
    const input = ev.target as HTMLInputElement;
    const raw = input.value || '';
    const onlyDigits = raw.replace(/\D+/g, '');

    if (moeda === 'PYG') {
      const intVal = onlyDigits ? parseInt(onlyDigits, 10) : 0;
      this.valorRecebidoEmGuarani = intVal;
      this.valorGuaraniStr = intVal
        ? intVal.toLocaleString('es-PY', { style: 'currency', currency: 'PYG', minimumFractionDigits: 0, maximumFractionDigits: 0 })
        : '';
      input.value = this.valorGuaraniStr;
    } else {
      const cents = onlyDigits ? parseInt(onlyDigits, 10) : 0;
      const val = cents / 100;
      if (moeda === 'USD') {
        this.valorRecebidoEmDolar = val;
        this.valorDolarStr = cents
          ? val.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 })
          : '';
        input.value = this.valorDolarStr;
      } else {
        this.valorRecebidoEmReal = val;
        this.valorRealStr = cents
          ? val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 })
          : '';
        input.value = this.valorRealStr;
      }
    }

    this.calcularTotaisDinheiro();

    const totalAPagar = this.calcularSubtotal() - (this.descontos || 0);
    this.corTotalEnviadoDinheiro =
      this.totalEnviado < totalAPagar ? 'red' :
      this.totalEnviado === totalAPagar ? 'green' : '#cdcd28';
  }

  calcularTotaisDinheiro(): void {
    // total pago e total a enviar em PYG para exibição agregada
    const pagoGuarani = this.valorRecebidoEmGuarani || 0;
    const pagoDolar = this.valorRecebidoEmDolar || 0;
    const pagoReal = this.valorRecebidoEmReal || 0;

    // Conversao Real: usa cotacao direta BRL->PYG se disponivel; fallback triangulacao
    const realParaPYG = this.cotRealGuarani
      ? this.cotRealGuarani
      : (this.cotPYG / this.cotBRL);
    const valorTotalPagoPYG = (pagoDolar * this.cotPYG) + pagoGuarani + (pagoReal * realParaPYG);
    const totalAEnviarPYG = this.fromUSD(this.totalAPagarUSD(), 'PYG');

    this.totalPago = valorTotalPagoPYG;
    this.totalEnviado = Math.min(valorTotalPagoPYG, totalAEnviarPYG);
    this.totalTroco = valorTotalPagoPYG > totalAEnviarPYG ? valorTotalPagoPYG - totalAEnviarPYG : 0;
  }

  /** NOVO: troco por moeda considera TODOS os inputs convertidos corretamente */
  calcularTroco(_valorRecebidoDaLinha: number, moedaTexto: string): number {
    const map: Record<string, 'USD'|'PYG'|'BRL'> = {
      'DOLAR': 'USD',
      'GUARANI': 'PYG',
      'REAL': 'BRL'
    };
    const m = map[moedaTexto] || 'USD';
    const troco = this.totalPagoEm(m) - this.totalAPagarEm(m);
    return troco > 0 ? troco : 0;
  }

  /** Pré-preenche a linha da moeda padrão com o total a pagar e seleciona a linha */
  private prefillMoneyDefault(): void {
    const totalAPagar = this.calcularSubtotal() - (this.descontos || 0);

    // zera tudo
    this.valorRecebidoEmGuarani = 0;
    this.valorRecebidoEmDolar = 0;
    this.valorRecebidoEmReal = 0;
    this.valorGuaraniStr = '';
    this.valorDolarStr = '';
    this.valorRealStr = '';

    if (this.moedaPadrao === 'PYG') {
      const intVal = Math.round(totalAPagar);
      this.valorRecebidoEmGuarani = intVal;
      this.valorGuaraniStr = intVal
        ? intVal.toLocaleString('es-PY', { style: 'currency', currency: 'PYG', minimumFractionDigits: 0 })
        : '';
      this.selectedMoneyCode = 'PYG';
    } else if (this.moedaPadrao === 'USD') {
      const val = totalAPagar;
      this.valorRecebidoEmDolar = val;
      this.valorDolarStr = val
        ? val.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 })
        : '';
      this.selectedMoneyCode = 'USD';
    } else {
      const val = totalAPagar;
      this.valorRecebidoEmReal = val;
      this.valorRealStr = val
        ? val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 })
        : '';
      this.selectedMoneyCode = 'BRL';
    }

    this.calcularTotaisDinheiro();
    const totalAP = this.calcularSubtotal() - (this.descontos || 0);
    this.corTotalEnviadoDinheiro =
      this.totalEnviado < totalAP ? 'red' :
      this.totalEnviado === totalAP ? 'green' : '#cdcd28';
  }

  /* ------------ Cache ------------ */
  salvarCache(): void {
    const cache = {
      carrinho: this.carrinho,
      descontos: this.descontos,
      tipoDeDesconto: this.tipoDeDesconto,
      valorDesconto: this.valorDesconto,
      clienteSelecionadoId: this.clienteSelecionado?.id ?? null,
      timbradoSelecionadoId: this.timbradoSelecionadoId,
      observacao: this.observacao,
      mostrarSemSaldo: this.mostrarSemSaldo,
      pedidoId: this.pedidoIdDoCache,
    };
    try { localStorage.setItem(this.cacheKey, JSON.stringify(cache)); } catch {}

    this.carrinhoService.setItems(this.carrinho);
  }

  restaurarCache(): void {
    try {
      const raw = localStorage.getItem(this.cacheKey);
      if (!raw) return;
      const cache = JSON.parse(raw);

      this.carrinho = Array.isArray(cache?.carrinho) ? cache.carrinho : [];
      this.descontos = Number(cache?.descontos || 0);
      this.tipoDeDesconto = cache?.tipoDeDesconto || null;
      this.valorDesconto = cache?.valorDesconto ?? null;

      // Backward compatibility: suporta tanto clienteSelecionado (objeto legado) quanto clienteSelecionadoId (novo)
      const clienteId = cache?.clienteSelecionadoId ?? cache?.clienteSelecionado?.id ?? null;
      if (clienteId) {
        this.pessoa_id = clienteId;
        // Buscar cliente da API pelo ID (não usar dados do cache)
        this.pessoaService.getById('/pessoas', String(clienteId)).subscribe({
          next: (pessoa) => {
            this.clienteSelecionado = pessoa;
          },
          error: () => {
            // Cliente do cache nao encontrado: limpar pessoa_id.
            // Nao sobrescrever clienteSelecionado se ja foi setado pelo aplicarClientePadrao()
            this.pessoa_id = null;
            if (!this.clienteSelecionado) {
              // Tentar aplicar padrao da empresa (pode ja ter clientePadraoId carregado)
              this.aplicarClientePadrao();
            }
          },
        });
      }

      // Backward compatibility: suporta tanto timbradoSelecionadoId (novo) quanto timbradoSelecionado (legado)
      const cachedTimbradoId = cache?.timbradoSelecionadoId ?? cache?.timbradoSelecionado?.id ?? null;
      if (cachedTimbradoId != null) {
        this.timbradoSelecionadoId = cachedTimbradoId;
        // timbradoSelecionado será sincronizado por aplicarTimbradoPadrao() após carregarTimbrados()
        if (cachedTimbradoId !== -1) {
          // Preserve o id para que aplicarTimbradoPadrao possa encontrar o objeto correto
          this.timbradoSelecionado = { value: null, id: cachedTimbradoId } as any;
        }
      }

      this.observacao = cache?.observacao || '';
      this.pedidoIdDoCache = cache?.pedidoId || null;
      this.mostrarSemSaldo = cache?.mostrarSemSaldo ?? true;

      this.carrinho.forEach((it) => {
        if (typeof it.valorTotalComDesconto !== 'number') {
          it.valorTotalComDesconto = (it.valorUnitario || 0) * (it.quantidade || 0);
        }
      });
      this.calcularSubtotal();
    } catch {}
  }

  /**
   * Revalida os saldos dos itens restaurados do cache usando a lista de produtos já carregada.
   * Remove itens sem saldo ou ajusta quantidade se saldo diminuiu.
   * NÃO faz requisições extras — usa this.produtosBrutos já carregado.
   */
  revalidarSaldosDoCache(): void {
    if (!this.carrinho || this.carrinho.length === 0) return;

    const itensRemovidos: string[] = [];
    const itensAjustados: string[] = [];
    const itensPrecoAtualizado: string[] = [];

    this.carrinho = this.carrinho.filter((itemCarrinho) => {
      // Itens vindos de pedidos delivery já foram aceitos: não verificar estoque
      if (itemCarrinho.origemPedido) return true;

      // Serviços não têm controle de saldo
      const isServico = this.ehServico(itemCarrinho) || this.ehServico({ tipoItem: itemCarrinho?.tipoItem });
      if (isServico) return true;

      // Busca o produto atualizado na lista carregada da API
      const produtoAtualizado = this.produtosBrutos.find((p: any) => p.id === itemCarrinho.item_id);

      // Produto não existe mais no catálogo
      if (!produtoAtualizado) {
        itensRemovidos.push(itemCarrinho.nome || String(itemCarrinho.item_id));
        return false;
      }

      const saldoAtual = Number(produtoAtualizado.saldo ?? 0);

      // Saldo zerado: remover item
      if (saldoAtual <= 0) {
        itensRemovidos.push(itemCarrinho.nome || String(itemCarrinho.item_id));
        return false;
      }

      // Atualizar saldo no item do carrinho
      itemCarrinho.saldo = saldoAtual;

      // Ajustar quantidade se excede o saldo atual
      if (itemCarrinho.quantidade > saldoAtual) {
        itemCarrinho.quantidade = saldoAtual;
        itemCarrinho.valorTotalComDesconto = (itemCarrinho.valorUnitario || 0) * saldoAtual;
        itensAjustados.push(itemCarrinho.nome || String(itemCarrinho.item_id));
      }

      // Revalidar preco apenas para itens SEM variante/modificador (preco base)
      const temVariante = itemCarrinho.variantesDePreco?.length > 0 || itemCarrinho.varianteDescricao;
      const temModificador = itemCarrinho.modificadores?.length > 0 || itemCarrinho.modificadoresDescricao;
      if (!temVariante && !temModificador) {
        const precoAtual = Number(produtoAtualizado.precoDeVenda ?? 0);
        if (precoAtual > 0 && precoAtual !== Number(itemCarrinho.valorUnitario ?? 0)) {
          itemCarrinho.valorUnitario = precoAtual;
          itemCarrinho.valorTotalComDesconto = precoAtual * itemCarrinho.quantidade;
          itensPrecoAtualizado.push(itemCarrinho.nome || String(itemCarrinho.item_id));
        }
      }

      return true;
    });

    if (itensRemovidos.length > 0) {
      this.messageService.add({
        severity: 'warn',
        summary: this.translate.instant('common.atencao'),
        detail: this.translate.instant('vendas.messages.itens_removidos_sem_saldo', { itens: itensRemovidos.join(', ') })
      });
    }

    if (itensAjustados.length > 0) {
      this.messageService.add({
        severity: 'info',
        summary: this.translate.instant('common.atencao'),
        detail: this.translate.instant('vendas.messages.itens_quantidade_ajustada', { itens: itensAjustados.join(', ') })
      });
    }

    if (itensPrecoAtualizado.length > 0) {
      this.messageService.add({
        severity: 'info',
        summary: this.translate.instant('common.atencao'),
        detail: this.translate.instant('vendas.messages.itens_preco_atualizado', { itens: itensPrecoAtualizado.join(', ') })
      });
    }

    if (itensRemovidos.length > 0 || itensAjustados.length > 0 || itensPrecoAtualizado.length > 0) {
      this.calcularSubtotal();
      this.salvarCache();
    }
  }

  /* ------------ Ordenação por COD quando sem busca ------------ */
  private sortProdutosByCodigoAsc(): void {
    const norm = (v: any) => {
      const s = (v ?? '').toString();
      const asNum = Number(s.replace(/\D+/g, ''));
      return Number.isFinite(asNum) ? asNum : s;
    };
    this.produtosBrutos = [...this.produtosBrutos].sort((a, b) => {
      const A = norm(a?.codigoItem);
      const B = norm(b?.codigoItem);
      if (typeof A === 'number' && typeof B === 'number') return A - B;
      return A.toString().localeCompare(B.toString(), undefined, { numeric: true, sensitivity: 'base' });
    });
  }

  /* ---------- Utilidades para o dialog "preço zero" ---------- */

  private formatarValorPorMoeda(valor: number, moeda: 'PYG'|'USD'|'BRL'|'ARS'): string {
    if (moeda === 'PYG') {
      return valor.toLocaleString('es-PY', { style: 'currency', currency: 'PYG', minimumFractionDigits: 0, maximumFractionDigits: 0 });
    }
    if (moeda === 'USD') {
      return valor.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 });
    }
    if (moeda === 'ARS') {
      // ARS delega ao CLDR `es-AR` que produz `$ N,NN`
      // (decisao tech lead 2026-05-06).
      return new Intl.NumberFormat('es-AR', {
        style: 'currency',
        currency: 'ARS',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(valor);
    }
    return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 });
  }

  onNovoPrecoInput(ev: Event): void {
    const input = ev.target as HTMLInputElement;
    const raw = input.value || '';
    const digits = raw.replace(/\D+/g, '');
    if (this.moedaPadrao === 'PYG') {
      const val = digits ? parseInt(digits, 10) : 0;
      this.valorNovoPrecoNumber = val;
      this.precoVendaNovoStr = this.formatarValorPorMoeda(val, 'PYG');
    } else {
      const cents = digits ? parseInt(digits, 10) : 0;
      const val = cents / 100;
      this.valorNovoPrecoNumber = val;
      this.precoVendaNovoStr = this.formatarValorPorMoeda(val, this.moedaPadrao as any);
    }
    input.value = this.precoVendaNovoStr;
  }

  confirmarNovoPreco(): void {
    if (!this.produtoParaDefinirPreco) return;
    if ((this.valorNovoPrecoNumber || 0) <= 0) {
      // mantém o dialog aberto até informar > 0
      return;
    }

    this.adicionarProdutoComPreco(this.produtoParaDefinirPreco, this.valorNovoPrecoNumber);
    this.mostrarDialogPreco = false;
    this.produtoParaDefinirPreco = null;

    const summary = this.translate.instant('vendas.toast.preco_definido_summary');
    const detail  = this.translate.instant('vendas.toast.preco_definido_carrinho');
    this.messageService.add({ severity: 'success', summary, detail });
  }

  cancelarNovoPreco(): void {
    this.mostrarDialogPreco = false;
    this.produtoParaDefinirPreco = null;
    const summary = this.translate.instant('vendas.toast.sem_preco_summary');
    const detail  = this.translate.instant('vendas.toast.sem_preco_detail');
    this.messageService.add({ severity: 'warn', summary, detail });
  }

  /* ------------ FATURA/INVOICE (Dialogo Pos-Venda) ------------ */

  /**
   * Carrega nota completa via GET /nota/{id} e itens via ItemsService.
   * Abre o dialogo de fatura apos carregamento.
   */
  carregarNotaCompleta(idNota: number): void {
    this.carregandoFatura = true;

    // Para PERGUNTAR, NADA_A_FAZER e IMPRIMIR, abre o dialog para exibir a fatura
    this.mostrarDialogoFatura = true;
    // Registrar timestamp para proteger o dialog de Enter residual do pagamento
    this.dialogFaturaAbertoEm = Date.now();

    this.notaService.get(`/nota/${idNota}`).subscribe({
      next: (response: any) => {
        this.notaCarregada = this.mapNotaDialogo(response);
        this.loadItensDoDialogo(this.notaCarregada.itemDeNota);

        // IMPRIMIR: imprimir automaticamente via iframe oculto (sem abrir nova aba)
        if (this.tipoImprimir === 'IMPRIMIR') {
          setTimeout(() => this.imprimirAutomatico(), 300);
        }
      },
      error: () => {
        this.carregandoFatura = false;
        this.mostrarDialogoFatura = false;
      }
    });
  }

  /**
   * Mapeia a resposta do GET /nota/{id} para NotaDTO tipado.
   * Extrai .enum dos campos enum-objetos (condicaoDePagamento, moeda, tipoDeTransacao).
   * Adaptado de FaturaViewComponent.mapNotaResponse().
   */
  private mapNotaDialogo(response: any): NotaDTO {
    return {
      id: response.id,
      emissao: response.emissao,
      emissaoFatura: response.emissaoFatura,
      codigoNota: response.codigoNota,
      tipoDeTransacao: response.tipoDeTransacao?.enum,
      ehFaturaLegal: response.ehFaturaLegal,
      numeroFatura: response.numeroFatura ?? 0,
      numeroPontoExpedicao: response.numeroPontoExpedicao ?? 0,
      valorCotacaoParaGuarani: response.valorCotacaoParaGuarani,
      valorTotalEmGuarani: response.valorTotalEmGuarani ?? 0,
      numeroFilial: response.numeroFilial ?? 0,
      numeroTimbrado: response.numeroTimbrado ?? '',
      chaveNotaEletronica: response.chaveNotaEletronica ?? '',
      valorTotalEmServicos: response.valorTotalEmServicos,
      valorTotalEmMercadorias: response.valorTotalEmMercadorias,
      timbrado_id: response.timbrado?.id ?? 0,
      tipoNota: response.tipoNota?.enum,
      condicaoDePagamento: response.condicaoDePagamento?.enum,
      conta_id: response.conta?.id ?? 0,
      moedaDaConta: response.moedaDaConta?.enum,
      cotacao_id: response.cotacao?.id ?? 0,
      custoTotalDosItens: response.custoTotalDosItens,
      valorTotal: response.valorTotal,
      valorTotalComDesconto: response.valorTotalComDesconto,
      valorDoDesconto: response.valorDoDesconto,
      tipoDeDesconto: response.tipoDeDesconto?.enum,
      porcentagemDesconto: response.porcentagemDesconto,
      valorRecebidoNaConta: response.valorRecebidoNaConta,
      valorRecebidoEmGuarani: response.valorRecebidoEmGuarani,
      valorRecebidoEmDolar: response.valorRecebidoEmDolar,
      valorRecebidoEmReal: response.valorRecebidoEmReal,
      informacaoDaTransacao: response.informacaoDaTransacao,
      moeda: response.moeda?.enum,
      valorBASEIVA10: response.valorBASEIVA10,
      valorIVA10: response.valorIVA10,
      valorBASEIVA5: response.valorBASEIVA5,
      valorIVA5: response.valorIVA5,
      valorBASEIVA0: response.valorBASEIVA0,
      valorIVA0: response.valorIVA0,
      valorTotalDoImposto: response.valorTotalDoImposto,
      cancelado: response.cancelado,
      observacao: response.observacao ?? '',
      empresaId: response.empresaId,
      criadoEm: response.criadoEm,
      atualizadoEm: response.atualizadoEm,
      pessoa_id: response.pessoa?.id ?? 0,
      nomePessoa: response.nomePessoa ?? '',
      vendedor_id: response.vendedor?.id ?? 0,
      nomeVendedor: response.nomeVendedor ?? '',
      itemDeNota: (response.itemDeNota ?? []).map((item: any) => ({ ...item, observacao: item.observacao || 'Observação' })),
      baixas: response.baixas ?? [],
      titulos: response.titulos ?? [],
      numeroParcelas: response.numeroParcelas ?? 0,
    };
  }

  /**
   * Carrega dados completos de cada item via ItemsService.getById().
   * Adaptado de FaturaViewComponent.loadItensDeNota().
   */
  private loadItensDoDialogo(itensDeNota: ItemDeNotaDTO[]): void {
    if (!itensDeNota || itensDeNota.length === 0) {
      this.itensCarregados = [];
      this.carregandoFatura = false;
      return;
    }

    const requisicoes = itensDeNota.map(item =>
      item.item_id
        ? this.itemsService.getById('/item', item.item_id.toString())
        : of(null as any)
    );

    forkJoin(requisicoes).subscribe({
      next: (response: (ItemDTO | null)[]) => {
        this.itensCarregados = response.map(r => r ?? ({ nome: '---', imagem: '' } as any));
        this.carregandoFatura = false;
      },
      error: () => {
        this.itensCarregados = [];
        this.carregandoFatura = false;
        this.messageService.add({
          severity: 'warn',
          summary: this.translate.instant('aviso'),
          detail: this.translate.instant('vendas.messages.erro_carregar_itens')
        });
      }
    });
  }

  /**
   * Formata valor em Peso Argentino (ARS) com simbolo `$`.
   *
   * Wrapper trivial sobre `Intl.NumberFormat('es-AR', { style:'currency', currency:'ARS' })`
   * que produz `$ N,NN` (decisao tech lead 2026-05-06; ver
   * `vendas-site/specs/feat-peso-argentino/05-simbolo-cifrao.md`).
   * Mantido como funcao para preservar callsites internos do componente.
   */
  private formatarPesoArgentino(valor: number | null | undefined): string {
    const numero = valor == null || isNaN(valor as number) ? 0 : (valor as number);
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(numero);
  }

  /**
   * Formata valor monetario conforme moeda (GUARANI, REAL, DOLAR).
   * Adaptado de FaturaViewComponent.formatarValorMonetario().
   */
  formatarValorMonetarioDialog(valor: number, moeda: string): string {
    if (valor == null || isNaN(valor)) return '-';

    let locale: string;
    let currencySymbol: string;

    switch (moeda) {
      case 'GUARANI':
        locale = 'es-PY';
        currencySymbol = 'Gs';
        break;
      case 'REAL':
        locale = 'pt-BR';
        currencySymbol = 'R$';
        break;
      case 'DOLAR':
        locale = 'en-US';
        currencySymbol = '$';
        break;
      case 'PESO':
        // ARS delega ao CLDR `es-AR` que produz `$ N,NN`
        // (decisao tech lead 2026-05-06).
        return this.formatarPesoArgentino(valor);
      default:
        locale = 'es-PY';
        currencySymbol = 'Gs';
        break;
    }

    const options: Intl.NumberFormatOptions =
      moeda === 'GUARANI'
        ? { minimumFractionDigits: 0, maximumFractionDigits: 0 }
        : { minimumFractionDigits: 2, maximumFractionDigits: 2 };

    const formatado = new Intl.NumberFormat(locale, options).format(valor);
    return `${currencySymbol} ${formatado}`;
  }

  /**
   * Formata data ISO para DD/MM/AAAA HH:mm.
   * Adaptado de FaturaViewComponent.formatarDataEHora().
   */
  formatarDataEHoraDialog(dataISO: string): string {
    if (!dataISO) return '';
    const data = new Date(dataISO);
    if (isNaN(data.getTime())) return '';

    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = data.getFullYear();
    const horas = String(data.getHours()).padStart(2, '0');
    const minutos = String(data.getMinutes()).padStart(2, '0');
    return `${dia}/${mes}/${ano} ${horas}:${minutos}`;
  }

  /**
   * Retorna label traduzida da condicao de pagamento.
   * Resolve o bug [object Object] usando i18n.
   */
  formatarCondicaoPagamento(condicao: string): string {
    if (!condicao) return '-';
    return this.translate.instant(`enums.condicao_de_pagamento.${condicao}`);
  }

  /** Foca o botao "Imprimir" ao abrir o dialogo de impressao */
  onDialogoImpressaoFaturaShow(): void {
    setTimeout(() => {
      this.btnImprimirFatura?.nativeElement?.focus();
    }, 0);
  }

  /**
   * Gera PDF da fatura no formato selecionado.
   * Se a nota for eletronica e foi transmitida com sucesso, imprime o KuDE (DANFE) via NfeService.
   * Caso contrario, imprime a fatura comum via NotaService.
   */

  /**
   * Impressao automatica via iframe oculto, sem abrir nova aba.
   * Usado exclusivamente para tipoImprimir === 'IMPRIMIR'.
   * O dialog de fatura permanece visivel enquanto o PDF e gerado em segundo plano.
   */
  private imprimirAutomatico(): void {
    if (!this.notaCarregada?.id) return;

    const formato = this.opcaoImpressaoFatura || 'BOBINA_58';
    const tipoNota = this.notaCarregada.tipoNota;

    const ehNfe = tipoNota && this.ehNotaEletronica(tipoNota) && this.transmissaoEstado === 'sucesso';

    const onBase64 = (pdfBase64: string) => {
      if (!pdfBase64) return;
      const byteCharacters = atob(pdfBase64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const blob = new Blob([new Uint8Array(byteNumbers)], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);

      // Reutilizar ou criar iframe oculto — nunca abre nova aba
      let iframe = document.getElementById('avati-iframe-impressao') as HTMLIFrameElement | null;
      if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.id = 'avati-iframe-impressao';
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
      }
      iframe.src = url;
      iframe.onload = () => {
        try {
          iframe!.contentWindow?.print();
        } catch {
          // Fallback: abrir em nova aba se o browser bloquear print() no iframe
          window.open(url, '_blank');
        }
      };
    };

    const onErro = () => {
      // Toast de erro exibido pelo HttpErrorInterceptor global
    };

    if (ehNfe) {
      this.nfeService.imprimirNfe(this.notaCarregada.id, formato).subscribe({
        next: (response: any) => onBase64(response?.pdfBase64 ?? ''),
        error: onErro
      });
    } else {
      this.notaService.gerarPdfNota(`/nota/gerar-pdf-nota/${this.notaCarregada.id}/impressao/${formato}`).subscribe({
        next: (pdfBase64: string) => onBase64(pdfBase64),
        error: onErro
      });
    }
  }

  /**
   * Observacao do item para o dialog de fatura — mesma regra da tela de fatura e dos PDFs
   * (ver `observacaoItemParaExibicao`).
   */
  observacaoVisivelDoItem(item: any, nomeItem?: string): string {
    return observacaoItemParaExibicao(item?.observacao, nomeItem);
  }

  gerarPdfFaturaDialog(): void {
    if (!this.notaCarregada?.id) return;

    const formato = this.opcaoImpressaoFatura || 'BOBINA_58';
    const tipoNota = this.notaCarregada.tipoNota;

    // Abrir nova aba para visualizacao manual (clique do usuario ou Ctrl+P)
    const janela = window.open('about:blank', '_blank');
    this.isImprimindoFatura = true;

    // Se nota eletronica e transmissao foi bem-sucedida, imprimir KuDE (DANFE)
    if (tipoNota && this.ehNotaEletronica(tipoNota) && this.transmissaoEstado === 'sucesso') {
      this.nfeService.imprimirNfe(this.notaCarregada.id, formato).subscribe({
        next: (response: any) => {
          this.isImprimindoFatura = false;
          if (response?.pdfBase64) {
            this.exibirPdf(response.pdfBase64, janela);
          } else {
            if (janela && !janela.closed) janela.close();
            this.messageService.add({
              severity: 'error',
              summary: this.translate.instant('vendas.common.erro'),
              detail: this.translate.instant('vendas.messages.erro_gerar_pdf')
            });
          }
        },
        error: () => {
          this.isImprimindoFatura = false;
          if (janela && !janela.closed) janela.close();
        }
      });
      return;
    }

    // Fatura comum (nao eletronica ou sem transmissao)
    this.notaService.gerarPdfNota(`/nota/gerar-pdf-nota/${this.notaCarregada.id}/impressao/${formato}`).subscribe({
      next: (pdfBase64: string) => {
        this.isImprimindoFatura = false;
        if (pdfBase64) {
          this.exibirPdf(pdfBase64, janela);
        } else {
          if (janela && !janela.closed) janela.close();
          this.messageService.add({
            severity: 'error',
            summary: this.translate.instant('vendas.common.erro'),
            detail: this.translate.instant('vendas.messages.erro_gerar_pdf')
          });
        }
      },
      error: () => {
        this.isImprimindoFatura = false;
        if (janela && !janela.closed) janela.close();
      }
    });
  }

  /**
   * Imprime a ficha do evento da venda recem-faturada, direto do dialogo pos-venda.
   * Espelha fatura-view.imprimirFicha(): o backend decide o template pela configuracao
   * da empresa (Tipo de Ficha do Evento), por isso enviamos apenas o notaId.
   */
  imprimirFichaDialog(): void {
    if (!this.notaCarregada?.id) return;

    // Abrir a aba no clique do usuario evita o bloqueio de popup do navegador
    const janela = window.open('about:blank', '_blank');
    this.isImprimindoFicha = true;

    this.notaService.gerarPdfFicha(this.notaCarregada.id).subscribe({
      next: (pdfBase64: string) => {
        this.isImprimindoFicha = false;
        if (pdfBase64) {
          this.exibirPdf(pdfBase64, janela);
        } else {
          if (janela && !janela.closed) janela.close();
          this.messageService.add({
            severity: 'error',
            summary: this.translate.instant('vendas.common.erro'),
            detail: this.translate.instant('vendas.messages.erro_imprimir_ficha')
          });
        }
      },
      error: () => {
        this.isImprimindoFicha = false;
        if (janela && !janela.closed) janela.close();
      }
    });
  }

  /**
   * Fecha o dialogo de fatura e reseta estado para nova venda.
   * Se o faturamento veio de um pedido, redireciona para /pedidos.
   */
  novaVendaDialog(): void {
    this.mostrarDialogoFatura = false;
    this.notaCarregada = null;
    this.itensCarregados = [];
    if (this.veioDePedido) {
      const queryParams = this.pedidoIdParaReabrir ? { abrirPedidoId: this.pedidoIdParaReabrir } : {};
      this.veioDePedido = false;
      this.pedidoIdParaReabrir = null;
      this.router.navigate(['/pedidos'], { queryParams });
      return;
    }
    setTimeout(() => this.searchInputRef?.nativeElement?.focus(), 100);
  }

  /**
   * Apenas fecha o dialogo sem resetar estado.
   * Se o faturamento veio de um pedido, redireciona para /pedidos.
   */
  fecharDialogoFatura(): void {
    this.mostrarDialogoFatura = false;
    if (this.veioDePedido) {
      const queryParams = this.pedidoIdParaReabrir ? { abrirPedidoId: this.pedidoIdParaReabrir } : {};
      this.veioDePedido = false;
      this.pedidoIdParaReabrir = null;
      this.router.navigate(['/pedidos'], { queryParams });
    }
  }

  private exibirPdf(pdfBase64: string, janela?: Window | null): void {
    const byteCharacters = atob(pdfBase64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    if (janela && !janela.closed) {
      janela.location.href = url;
    } else {
      // Fallback: criar link e clicar programaticamente
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.click();
    }
  }

  /* ------------ NOVO CLIENTE (F9) ------------ */
  abrirDialogNovoCliente(): void {
    this.mostrarDialogNovoCliente = true;
  }

  /** Handler: pessoa nova cadastrada via PessoaAdicionarDialogComponent */
  onClienteCriado(pessoa: PessoaDTO): void {
    this.clienteSelecionado = pessoa;
    this.pessoa_id = pessoa.id ?? null;
    this.salvarCache();
  }

  /** Handler: pessoa ja existente encontrada via RUC no PessoaAdicionarDialogComponent */
  onClienteVinculado(pessoa: PessoaDTO): void {
    if (pessoa.id != null) {
      this.clienteSelecionado = pessoa;
      this.pessoa_id = pessoa.id;
      this.salvarCache();
    }
  }


  /* ------------ DIALOG DADOS CLIENTE NFE ------------ */
  fecharDialogDadosClienteNfe(): void {
    this.mostrarDialogDadosClienteNfe = false;
  }

  editarClienteNfe(): void {
    this.mostrarDialogDadosClienteNfe = false;
    if (this.clienteSelecionado?.id) {
      window.open(`/clientes?edit=${this.clienteSelecionado.id}`, '_blank');
    }
  }

  prosseguirSemDadosClienteNfe(): void {
    this.mostrarDialogDadosClienteNfe = false;
    void this.abrirPagamentoComCotacao();
  }

  /* ------------ COTAÇÃO ------------ */
  /** Carrega a cotacao mais recente para preencher cotPYG/cotBRL usados em conversoes */
  carregarCotacaoAtual(): void {
    this.cotacaoService.get('/cotacao/ultimaCotacao').subscribe({
      next: (res: any) => {
        if (res) {
          this.cotPYG = res.dolarGuarani || 7180;
          this.cotBRL = res.dolarReal || 5.47;
          // pesoGuarani e opcional; sem valor, coluna peso permanece oculta
          this.cotPesoGuarani = res.pesoGuarani ?? 0;
          // realGuarani: cotacao direta BRL->PYG; 0 = fallback triangulacao
          this.cotRealGuarani = res.realGuarani || 0;
        }
      },
      error: () => {
        // Usa valores padrao se nao encontrar cotacao
      }
    });
  }

  // ---- Transmissao Automatica NFe ----

  /**
   * Retransmite a NFe a partir do dialog de erro (retry).
   */
  retransmitirNfe(): void {
    if (this.idNotaParaTransmissao) {
      this.transmitirNfeAutomatica(this.idNotaParaTransmissao);
    }
  }

  /**
   * Verifica se o tipo da nota e eletronica (requer transmissao automatica).
   */
  private ehNotaEletronica(tipoNota: string): boolean {
    return tipoNota === 'ELETRONICA';
  }

  /**
   * Transmite automaticamente a NFe apos a criacao da nota.
   * Exibe dialogo informativo com progresso e transiciona para
   * o dialogo "Fatura Gerada" em caso de sucesso.
   */
  private async transmitirNfeAutomatica(notaId: number): Promise<void> {
    this.idNotaParaTransmissao = notaId;
    this.transmissaoEstado = 'transmitindo';
    this.transmissaoProgresso = 0;
    this.transmissaoMensagem = '';
    this.mostrarDialogoTransmissao = true;

    try {
      // Progresso visual inicial
      this.transmissaoProgresso = 25;
      await this.delay(500);
      this.transmissaoProgresso = 50;

      // Transmitir NFe (retorna List<NotaEletronicaEventoEnvio>)
      await firstValueFrom(
        this.nfeService.post(`/nfe/transmitir/${notaId}`, undefined)
      );

      this.transmissaoProgresso = 75;

      // Consultar estado real da nota apos transmissao
      const consultaResponse: any = await firstValueFrom(
        this.nfeService.getById(`/nfe/consultar`, notaId.toString())
      );

      // A resposta da consulta eh um array - pegar o primeiro elemento
      const dadosNfe = Array.isArray(consultaResponse) && consultaResponse.length > 0
        ? consultaResponse[0]
        : consultaResponse;

      const descMensagem = dadosNfe?.descMensagem?.trim().toUpperCase() || '';
      const sucesso = ['AUTORIZADO', 'AUTORIZADA', 'APROVADO', 'APROVADA'].includes(descMensagem);

      if (sucesso) {
        this.transmissaoEstado = 'sucesso';
        this.transmissaoProgresso = 100;

        // Transicao automatica para "Fatura Gerada" apos 1.5s
        await this.delay(1500);
        this.mostrarDialogoTransmissao = false;
        this.carregarNotaCompleta(notaId);
      } else {
        // Transmissao retornou mas nao foi autorizada
        this.transmissaoEstado = 'erro';

        // Extrair mensagem real de rejeicao da SIFEN do campo list (retornos)
        const mensagemRejeicao = this.extrairMensagemRejeicaoSifen(dadosNfe);
        this.transmissaoMensagem = mensagemRejeicao
          || sanitizarMensagemErro(
            dadosNfe?.descMensagem,
            this.translate.instant('vendas.transmissao.mensagem_erro_conexao')
          );
        this.transmissaoProgresso = 0;
      }
    } catch (error: any) {
      console.error('Erro na transmissao automatica NFe:', error);
      this.transmissaoEstado = 'erro';
      this.transmissaoMensagem = extrairMensagemErroHttp(
        error,
        this.translate.instant('vendas.transmissao.mensagem_erro_conexao')
      );
      this.transmissaoProgresso = 0;
    }
  }

  /**
   * Extrai a mensagem real de rejeicao da SIFEN do campo list (retornos do governo).
   * O campo list contem NotaEletronicaEventoRetorno com descMensagem detalhada.
   */
  private extrairMensagemRejeicaoSifen(dadosNfe: any): string | null {
    if (!dadosNfe?.list || !Array.isArray(dadosNfe.list) || dadosNfe.list.length === 0) {
      return null;
    }

    // Pegar a ultima mensagem de retorno (mais recente)
    const ultimoRetorno = dadosNfe.list[dadosNfe.list.length - 1];
    const mensagem = ultimoRetorno?.descMensagem?.trim();

    if (!mensagem || mensagem.length === 0) {
      return null;
    }

    // Se a mensagem for tecnica, sanitizar retorna '' — nesse caso retornar null para usar fallback
    const sanitizada = sanitizarMensagemErro(mensagem, '');
    return sanitizada || null;
  }

  /** Helper para delay em millisegundos */
  private delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

  /**
   * Fecha o dialogo de transmissao (estado erro) e abre o dialogo "Fatura Gerada".
   */
  fecharDialogoTransmissaoEVerFatura(): void {
    this.mostrarDialogoTransmissao = false;
    if (this.idNotaParaTransmissao) {
      this.carregarNotaCompleta(this.idNotaParaTransmissao);
    }
  }

  /* ========== Variantes e Modificadores ========== */

  /**
   * Verifica se o item possui variantes ou modificadores.
   * Se sim, abre o dialog de selecao. Se nao, segue fluxo normal.
   */
  private verificarVariantesEModificadores(produto: any, preco: number, quantidadeDesejada?: number): void {
    const itemId = produto.id;

    // Usar cache se disponivel
    const variantesCache = this.cacheVariantes.get(itemId);
    const gruposCache = this.cacheGruposModificadores.get(itemId);

    if (variantesCache !== undefined && gruposCache !== undefined) {
      this.processarVariantesEModificadores(produto, preco, variantesCache, gruposCache, quantidadeDesejada);
      return;
    }

    this.carregandoVariantes = true;
    forkJoin({
      variantes: this.produtoVarianteModificadorService.getVariantes(itemId).pipe(
        catchError(() => of([] as VarianteDePrecoDeItemDTO[]))
      ),
      grupos: this.produtoVarianteModificadorService.getGrupos(itemId).pipe(
        catchError(() => of([] as GrupoDeModificadorDePrecoDeItemDTO[]))
      ),
    }).subscribe(({ variantes, grupos }) => {
      this.carregandoVariantes = false;

      // Salvar no cache
      const listaVariantes = Array.isArray(variantes) ? variantes : [];
      const listaGrupos = Array.isArray(grupos) ? grupos : [];
      this.cacheVariantes.set(itemId, listaVariantes);
      this.cacheGruposModificadores.set(itemId, listaGrupos);

      this.processarVariantesEModificadores(produto, preco, listaVariantes, listaGrupos, quantidadeDesejada);
    });
  }

  private processarVariantesEModificadores(
    produto: any,
    preco: number,
    variantes: VarianteDePrecoDeItemDTO[],
    grupos: GrupoDeModificadorDePrecoDeItemDTO[],
    quantidadeDesejada?: number
  ): void {
    const temVariantes = variantes && variantes.length > 0;
    const temModificadores = grupos && grupos.length > 0;

    if (temVariantes || temModificadores) {
      // Caso com dialog: a multiplicacao do termo de busca e ignorada de proposito.
      this.abrirDialogVarianteModificador(produto, variantes, grupos);
    } else {
      this.adicionarProdutoComPreco(produto, preco, quantidadeDesejada);
    }
  }

  abrirDialogVarianteModificador(
    produto: any,
    variantes: VarianteDePrecoDeItemDTO[],
    grupos: GrupoDeModificadorDePrecoDeItemDTO[]
  ): void {
    this.produtoParaVariante = produto;
    this.variantesDisponiveis = variantes || [];
    this.gruposModificadores = grupos || [];
    this.varianteSelecionada = null;
    this.modificadoresQuantidade = new Map();
    this.calcularPrecoVarianteModificador();
    this.mostrarDialogVarianteModificador = true;
  }

  fecharDialogVarianteModificador(): void {
    this.mostrarDialogVarianteModificador = false;
    this.produtoParaVariante = null;
    this.variantesDisponiveis = [];
    this.gruposModificadores = [];
    this.varianteSelecionada = null;
    this.modificadoresQuantidade = new Map();
    this.precoCalculadoVariante = 0;
  }

  selecionarVariante(variante: VarianteDePrecoDeItemDTO): void {
    this.varianteSelecionada = variante;
    this.calcularPrecoVarianteModificador();
  }

  toggleModificador(grupo: GrupoDeModificadorDePrecoDeItemDTO, modificador: ModificadorDePrecoDeItemDTO): void {
    if (grupo.maximoDeModificadores === 1) {
      // Radio: substituir selecao
      const quantidades = this.modificadoresQuantidade.get(grupo.id!) || new Map();
      const jaSelecioando = (quantidades.get(modificador.id!) || 0) > 0;
      quantidades.clear();
      if (!jaSelecioando) {
        quantidades.set(modificador.id!, 1);
      }
      this.modificadoresQuantidade.set(grupo.id!, new Map(quantidades));
    } else {
      // Para grupos com max > 1, clicar na linha incrementa em 1 (se quantidade era 0) ou remove (se ja tinha)
      const qtdAtual = this.getQuantidadeModificador(grupo.id!, modificador.id!);
      if (qtdAtual === 0) {
        this.incrementarModificador(grupo, modificador);
      } else {
        this.setQuantidadeModificador(grupo.id!, modificador.id!, 0);
      }
    }
    this.calcularPrecoVarianteModificador();
  }

  incrementarModificador(grupo: GrupoDeModificadorDePrecoDeItemDTO, modificador: ModificadorDePrecoDeItemDTO): void {
    const totalGrupo = this.getTotalSelecoesGrupo(grupo.id!);
    if (totalGrupo >= grupo.maximoDeModificadores) return;

    const qtdAtual = this.getQuantidadeModificador(grupo.id!, modificador.id!);
    this.setQuantidadeModificador(grupo.id!, modificador.id!, qtdAtual + 1);
    this.calcularPrecoVarianteModificador();
  }

  decrementarModificador(grupoId: number, modificadorId: number): void {
    const qtdAtual = this.getQuantidadeModificador(grupoId, modificadorId);
    if (qtdAtual <= 0) return;
    this.setQuantidadeModificador(grupoId, modificadorId, qtdAtual - 1);
    this.calcularPrecoVarianteModificador();
  }

  getQuantidadeModificador(grupoId: number, modificadorId: number): number {
    return this.modificadoresQuantidade.get(grupoId)?.get(modificadorId) || 0;
  }

  private setQuantidadeModificador(grupoId: number, modificadorId: number, quantidade: number): void {
    let quantidades = this.modificadoresQuantidade.get(grupoId);
    if (!quantidades) {
      quantidades = new Map();
      this.modificadoresQuantidade.set(grupoId, quantidades);
    }
    if (quantidade <= 0) {
      quantidades.delete(modificadorId);
    } else {
      quantidades.set(modificadorId, quantidade);
    }
  }

  isModificadorSelecionado(grupoId: number, modificadorId: number): boolean {
    return this.getQuantidadeModificador(grupoId, modificadorId) > 0;
  }

  getTotalSelecoesGrupo(grupoId: number): number {
    const quantidades = this.modificadoresQuantidade.get(grupoId);
    if (!quantidades) return 0;
    let total = 0;
    quantidades.forEach(qty => total += qty);
    return total;
  }

  isGrupoMaxAtingido(grupoId: number, maximoDeModificadores: number): boolean {
    return this.getTotalSelecoesGrupo(grupoId) >= maximoDeModificadores;
  }

  calcularPrecoVarianteModificador(): void {
    const precoBase = Number(this.produtoParaVariante?.precoDeVenda ?? 0);
    const precoVariante = this.varianteSelecionada
      ? this.varianteSelecionada.precoDeVenda
      : precoBase;

    let totalModificadores = 0;
    // Iterar por todos os grupos para calcular preco * quantidade
    for (const grupo of this.gruposModificadores) {
      const quantidades = this.modificadoresQuantidade.get(grupo.id!);
      if (!quantidades) continue;
      for (const mod of grupo.modificadores) {
        const qty = quantidades.get(mod.id!) || 0;
        totalModificadores += mod.precoDeVenda * qty;
      }
    }

    this.precoCalculadoVariante = precoVariante + totalModificadores;
  }

  get podeConfirmarVarianteModificador(): boolean {
    // Se tem variantes, deve ter uma selecionada
    if (this.variantesDisponiveis.length > 0 && !this.varianteSelecionada) {
      return false;
    }

    // Verificar minimo de modificadores por grupo
    for (const grupo of this.gruposModificadores) {
      if (grupo.minimoDeModificadores > 0) {
        const total = this.getTotalSelecoesGrupo(grupo.id!);
        if (total < grupo.minimoDeModificadores) {
          return false;
        }
      }
    }

    return true;
  }

  // Mensagem de validacao para exibir quando botao Confirmar esta desabilitado
  get mensagemValidacaoVariante(): string {
    if (this.variantesDisponiveis.length > 0 && !this.varianteSelecionada) {
      return this.translate.instant('vendas.variantes.selecione_variante_para_continuar');
    }
    for (const grupo of this.gruposModificadores) {
      if (grupo.minimoDeModificadores > 0) {
        const total = this.getTotalSelecoesGrupo(grupo.id!);
        if (total < grupo.minimoDeModificadores) {
          return this.translate.instant('vendas.variantes.selecione_modificadores_para_continuar');
        }
      }
    }
    return '';
  }

  // Breakdown do preco para exibicao detalhada
  get breakdownPreco(): { descricao: string; valor: number; tipo: string; quantidade?: number }[] {
    const items: { descricao: string; valor: number; tipo: string; quantidade?: number }[] = [];

    if (this.varianteSelecionada) {
      items.push({
        descricao: this.varianteSelecionada.descricao,
        valor: this.varianteSelecionada.precoDeVenda,
        tipo: 'variante'
      });
    } else if (this.produtoParaVariante) {
      items.push({
        descricao: this.produtoParaVariante.nome,
        valor: Number(this.produtoParaVariante.precoDeVenda ?? 0),
        tipo: 'base'
      });
    }

    for (const grupo of this.gruposModificadores) {
      const quantidades = this.modificadoresQuantidade.get(grupo.id!);
      if (!quantidades) continue;
      for (const mod of grupo.modificadores) {
        const qty = quantidades.get(mod.id!) || 0;
        if (qty > 0) {
          items.push({
            descricao: mod.descricao,
            valor: mod.precoDeVenda * qty,
            tipo: 'modificador',
            quantidade: qty
          });
        }
      }
    }

    return items;
  }

  // Verifica se um grupo de modificadores atingiu o minimo obrigatorio
  isGrupoComMinimoPendente(grupo: GrupoDeModificadorDePrecoDeItemDTO): boolean {
    if (grupo.minimoDeModificadores <= 0) return false;
    return this.getTotalSelecoesGrupo(grupo.id!) < grupo.minimoDeModificadores;
  }

  confirmarSelecaoVarianteModificador(): void {
    if (!this.podeConfirmarVarianteModificador || !this.produtoParaVariante) return;

    // Coletar modificadores com suas quantidades
    const modsComQuantidade: { mod: ModificadorDePrecoDeItemDTO; quantidade: number }[] = [];
    for (const grupo of this.gruposModificadores) {
      const quantidades = this.modificadoresQuantidade.get(grupo.id!);
      if (!quantidades) continue;
      for (const mod of grupo.modificadores) {
        const qty = quantidades.get(mod.id!) || 0;
        if (qty > 0) {
          modsComQuantidade.push({ mod, quantidade: qty });
        }
      }
    }

    this.adicionarProdutoComVarianteModificador(
      this.produtoParaVariante,
      this.precoCalculadoVariante,
      this.varianteSelecionada,
      modsComQuantidade
    );

    this.fecharDialogVarianteModificador();
  }

  private adicionarProdutoComVarianteModificador(
    produto: any,
    precoFinal: number,
    varianteSelecionada: VarianteDePrecoDeItemDTO | null,
    modsComQuantidade: { mod: ModificadorDePrecoDeItemDTO; quantidade: number }[]
  ): void {
    // Montar variantes para o payload
    const variantesDePreco: VarianteDePrecoDeItemPedidoDTO[] = varianteSelecionada
      ? [{
          codigoDaVariante: String(varianteSelecionada.id),
          descricao: varianteSelecionada.descricao,
          quantidade: 1,
          precoDeVenda: varianteSelecionada.precoDeVenda,
          precoTotal: varianteSelecionada.precoDeVenda,
        }]
      : [];

    // Montar modificadores para o payload (com quantidade correta)
    const modificadores: ModificadorDePrecoDeItemPedidoDTO[] =
      modsComQuantidade.map(({ mod, quantidade }) => ({
        codigoDoModificador: String(mod.id),
        descricao: mod.descricao,
        quantidade: quantidade,
        precoDeVenda: mod.precoDeVenda,
        precoTotal: mod.precoDeVenda * quantidade,
      }));

    // Descricao com quantidade para exibicao no carrinho
    const modificadoresDescricao = modsComQuantidade
      .map(({ mod, quantidade }) => quantidade > 1 ? `${mod.descricao} (x${quantidade})` : mod.descricao)
      .join(', ') || null;

    const novoItem = {
      item_id: produto.id,
      tipoDeImposto: produto.tipoDeImposto,
      quantidade: 1,
      valorUnitario: precoFinal,
      custoUnitario: produto.custo,
      custoTotal: produto.custo,
      valorTotal: precoFinal,
      desconto: produto.desconto || 0,
      valorUnitarioComDesconto: 0,
      valorTotalComDesconto: precoFinal,
      precoDeVendaNovo: precoFinal,
      precoDeVendaAntigo: produto.precoDeVenda,
      tipoDeDesconto: produto.tipoDeDesconto || 'SEM_DESCONTO',
      nome: produto.nome,
      imagem: produto.imagem,
      saldo: produto.saldo,
      estoqueMinimo: produto.estoqueMinimo,
      tipoItem: produto.tipoItem,
      codigoItem: produto.codigoItem ?? '',
      barras: produto.barras ?? '',
      variantesDePreco: variantesDePreco,
      modificadores: modificadores,
      // Campos auxiliares para exibicao no carrinho
      varianteDescricao: varianteSelecionada?.descricao || null,
      modificadoresDescricao: modificadoresDescricao,
    };

    // Itens com variante/modificador NAO agrupam (cada selecao = nova linha)
    this.carrinho.unshift(novoItem);
    this.atualizarValores(novoItem);
    this.salvarCache();
  }

  /**
   * Navega para a pagina de detalhes da fatura para ver mais informacoes.
   */
  irParaDetalhesFatura(): void {
    this.mostrarDialogoTransmissao = false;
    if (this.idNotaParaTransmissao) {
      this.router.navigate([`/notas-list/fatura/${this.idNotaParaTransmissao}`]);
    }
  }
}

